<template>
  <div class="retailOrderSubmitpage" >
    <div class="pageContent">
      <XR-head titleText="订单确认" :rightShow="true" ref="headObj"></XR-head>
       
      <router-link to="/usercenter/address?redirecturl=/usercenter/address">
        <div class="receive-address">    
          <span style="line-height: 40px;font-weight: bold;" v-if="!receiveAddress.Receiver">请选择收货地址</span>
          <div class="mapIcon">
            <img src="/static/icon/address-location.png" />
          </div>
          <div class="address-info" :style="{width:addressInfoWidth+'px'}" v-if="receiveAddress.Receiver">         
            <div class="contract">
              <span class="name">{{receiveAddress.Receiver}}</span>
              <span class="mobile">{{receiveAddress.Phone}}</span>              
            </div>
            <div class="address-content">
              <span class="text">{{receiveAddress.DetailAddress}}</span>
            </div>
          </div>
          <div class="goIcon">
            <i class="fa fa-angle-right"></i>
          </div>
        </div>
      </router-link>

      <template v-for="(shopItem,index) in productInfoList"> 
        <div class="shopProductList" :key="shopItem.ShopId">
          <div class="shopRow">          
            <!-- <div class="all-chk"><mu-checkbox class="cart-all-chk" :nativeValue="cartItem.ShopId" @change="shopClick(cartItem.ShopId)" uncheckIcon=":fa fa-circle-thin" checkedIcon=":fa fa-yes"/></div> -->
            <div class="shopName">
              <img :src="shopItem.ShopLogo" class="shopLogo" />
              <div class="shopNameValue">
                <span>{{shopItem.ShopName}}</span>
                <i class="fa fa-angle-right"></i>
              </div>
            </div>      
          </div>    
          <div class="pro-list">
            <div class="pro-item"  v-for="pItem in shopItem.Products" :key="pItem.SkuId">  
              <div class="pro-img">
                <img :src="pItem.DefaultImg?pItem.DefaultImg:IMGServer_URL+'/images/index-item-default.png'" />
              </div>
              <div class="pro-info" :style="{width:cartItemProductInfoWidth+'px'}">
                <p class="pro-name">{{pItem.Name}}</p>
                <p class="pro-attr">
                  <template v-for="attrItem in pItem.Attrs">
                    {{attrItem.AttrName +":" + attrItem.AttrValue}} 
                  </template>
                </p>
                <div class="pro-num">
                  <p class="pro-price">              
                    <template v-if="pItem.State==0">
                      <i class="fa fa-rmb"></i>{{pItem.SalePrice.toFixed(2)}}
                    </template>
                    <template v-else>
                      商品已下架
                    </template>
                  </p>
                  <div class="jiajian-ctrl">
                    <!--<span class="btn jian">-</span>
                    <span class="count">{{getCartItemCount(pItem.SkuId)}}</span>
                    <span class="btn jia">+</span>-->
					x {{getCartItemCount(pItem.SkuId)}}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="choose-info delivery" v-if="shopItem.DeliveryType != 3" @click="choseDelivery(shopItem.ShopId, shopItem.Products.length)">
            <div class="info left">
              <div class="choose-row title">选择配送</div>
            </div>
            <div :class="'goIcon wuliu'" style="width:25px;line-height:20px;">
              <!--<i class="fa fa-angle-right"></i>-->
			  <img src="/static/coupon/coupon_more.png" width="25" height="7">
            </div>
            <div class="info center" :style="{width:devWidth+'px'}">
              <template v-if="!shopItem.DeliveryType || shopItem.DeliveryType<=0">
                <div class="choose-row one">请选择</div>   
              </template>
              <template v-if="shopItem.DeliveryType>0">                  
                <div class="choose-row">{{shopItem.DeliveryTypeName}}</div>   
                <div class="choose-row">{{shopItem.DeliveryDateName}}</div>   
              </template>     
            </div>
          </div>
          <div class="choose-info delivery" v-if="shopItem.DeliveryType == 3" @click="choseDelivery(shopItem.ShopId, shopItem.Products.length)">
            <div class="info left">
              <div class="choose-row title">选择自提点</div>
            </div>    
            <div class="goIcon selfPick" style="width:25px">
              <!--<i class="fa fa-angle-right"></i>-->
			        <img src="/static/coupon/coupon_more.png" width="25" height="7">
            </div>           
            <div class="info center" v-if="!shopItem.SelfPickUpInfo.shopId"> 
              <div class="choose-row one">请选择</div>           
            </div>
            <div class="info center" v-if="shopItem.SelfPickUpInfo.shopId"> 
              <div class="choose-row">{{shopItem.SelfPickUpInfo.shopName}}</div> 
              <div class="choose-row">{{shopItem.SelfPickUpInfo.address}}</div>           
            </div>  
          </div>   
          <div class="choose-info delivery" v-if="shopItem.DeliveryType == 3" @click="openSelfPickUpDatePopup(shopItem.ShopId)">
            <div class="info left">
              <div class="choose-row title">选择时间</div>
            </div>    
            <div class="goIcon" style="width:25px;">
              <!--<i class="fa fa-angle-right"></i>-->
			        <img src="/static/coupon/coupon_more.png" width="25" height="7">
            </div> 
            <div class="info center" > 
              <div class="choose-row">{{shopItem.SelfPickUpDate1}} {{shopItem.SelfPickUpDate2}}</div>        
            </div>       
          </div>
          <div v-if="shopIds[shopItem.ShopId] && !closeCoupon" class="choose-info shopCoupon" @click="openShopCoupon(shopItem.ShopId, shopItem.Products)">
            <div class="info left">
              <div class="choose-row title">店铺优惠</div>
            </div>    
            <div class="goIcon coupon" style="width:25px;">
              <!--<i class="fa fa-angle-right"></i>-->
			  <img src="/static/coupon/coupon_more.png" width="25" height="7">
            </div>           
            <div class="info center" v-if="!shopItem.couponInfo"> 
              <div class="choose-row one">请选择</div>           
            </div>
            <div class="info center" v-if="shopItem.couponInfo"> 
              <div class="choose-row">{{shopItem.couponInfo}}</div>          
            </div>  
          </div>
          <div class="remark" v-if="shopItem.DeliveryType == 3 && orderSubmitDto.addrId == '0'">
            <mu-text-field label="联系电话" labelFloat fullWidth v-on:input="saveMobile(index)" v-model="shopItem.Mobile" type="number" helpText="方便商家联系您"/>
          </div>
          <div class="remark">
            <mu-text-field label="留言" hintText="最长不超过50个字符" v-on:input="saveRemark(index)" v-model="shopItem.Remark" fullWidth multiLine :rows="1" :rowsMax="6" helpText="选填:给商家留言" :errorText="multiLineInputErrorText" @textOverflow="handleMultiLineOverflow" :maxLength="50"/>
          </div>
          <div class="area-total">
            <p class="right"><i class="fa fa-rmb"></i>{{shopItem.TotalMoney+getFreightCache(shopItem.ShopId)-shopItem.ShopCouponMoney}}元</p>
            <p class="center">小计：</p>
            <p class="left">共计<span>{{shopItem.CartCount}}</span>件，运费<span>{{getFreightCache(shopItem.ShopId)}}</span>元</p>
          </div>
        </div>
      </template>
    
      <div class="info-area">        
        <div class="choose-info fapiao-area" v-if="IsInvoice == 1">
          <div class="info left" style="width:unset;">
            <div class="choose-row title">发票</div>
            <div class="choose-row" v-if="orderSubmitDto.InvoiceHead != ''">抬头：{{orderSubmitDto.InvoiceHead}}</div>
          </div>   
          <div class="info right" :style="{width:chooseInfoWidth+'px'}">
            <div class="choose-row"><mu-switch v-model="isFapiao" /></div>
          </div>
          <mu-popup position="bottom" popupClass="retailOrderSubmitpage-popupLayer fapiao" :open="fapiaoPopup" @close="closeFapiao()">
            <div class="deliveryChoose">
              <mu-text-field fullWidth label="发票抬头" hintText="请输入发票抬头" helpText="抬头不能超过25个汉字" v-model="orderSubmitDto.InvoiceHead" :maxLength="25" />
            </div>
            <mu-raised-button primary @click="closeChooseFapiao()" fullWidth class="delvieryChooseBtn" label="确定"/>
          </mu-popup>
        </div>
        <!-- <div class="choose-info integral">
          <div class="info left">
            <div class="choose-row title">积分</div>
            <div class="choose-row">余额：<span>{{memberIntegral.Integral}}</span></div>
            <div class="choose-row balance">可抵扣：<span>{{integralTotalPrice}}元</span></div>
          </div>
          <div class="info center" :style="{width:chooseInfoWidth+'px'}">
            <div class="choose-row"><mu-switch v-model="isIntegral" /></div>
            <div class="choose-row">{{isIntegral?'积分抵扣'+orderInfo.integral+'元':'无'}}</div>

            <div class="choose-row integralModify" v-if="isIntegral" @click="integralPopup=true">修改</div>
            <div class="choose-row" v-if="!isIntegral" >&nbsp;</div>
          </div>
          //<div class="goIcon">
          //  <i class="fa fa-angle-right"></i>
          //</div>
          <mu-popup position="bottom" popupClass="retailOrderSubmitpage-popupLayer integral" :open="integralPopup">
            <div class="deliveryChoose">
              <mu-text-field fullWidth label="请输入要抵扣的积分" :errorText="integralErrorText"  type="number" labelFloat v-model="integral" />
            </div>
            <mu-raised-button primary @click="closeChoose('integral')" fullWidth class="delvieryChooseBtn" label="确定"/>
          </mu-popup>
        </div> -->
		
        <div class="choose-info integral">
          <div class="info left" style="width:unset;">
            <div class="choose-row title">BAW</div>
            <div class="choose-row">余额：<br><span>{{candyBalance.toFixed(this.candyDecimal)}}</span></div>
            <!-- <div class="choose-row balance">可抵扣：<span>{{0}}{{candyName}}</span></div> -->
          </div>
          <div class="info right" :style="{width:chooseInfoWidth+'px'}">
            <div class="choose-row"><mu-switch v-model="isCandy" :disabled="isDisabled" /></div>
            <div class="choose-row balance" :style="{color:isCandy?'red':'#A0A0A0',marginTop:'16px'}">可抵扣：<span>{{showMoney.toFixed(this.candyDecimal)}}BAW</span></div>
            <!-- <div class="choose-row">{{isCandy?'已使用'+orderSubmitDto.baw.toFixed(this.candyDecimal)+candyName:'无'}}</div>
            <div class="choose-row integralModify" v-if="isCandy" @click="candyPopup=true">修改</div>
            <div class="choose-row" v-if="!isCandy" >&nbsp;</div> -->
          </div>
          <!-- <div class="goIcon">
            <i class="fa fa-angle-right"></i>
          </div> -->
          <!-- <mu-popup position="bottom" popupClass="retailOrderSubmitpage-popupLayer integral" :open="candyPopup">
            <div class="deliveryChoose">
              <mu-text-field fullWidth label="请输入要抵扣的BAW" :errorText="candyErrorText" type="number" labelFloat />
            </div>
            <mu-raised-button primary @click="closeChooseBaw()" fullWidth class="delvieryChooseBtn" label="确定"/>
          </mu-popup> -->
        </div>

      </div>

      <div class="platformCouponChooseList" v-if = "HasPlatformCoupon0 && !closeCoupon">        
        <div class="choose-info platformCoupon">          
          <div class="info left">
            <div class="choose-row title">平台优惠</div>
          </div>
          <div class="info center" :style="{width: platformCouponCenterWidth+'px'}">     
            <div class="couponSelectList">
              <div class="couponListItem" @click="openPlatformCoupon(1)">
                <div class="couponIcon">
                  <div class="couponIconContent">
                    已选{{orderSubmitDto.platformCouponList.length}}张
                  </div>
                </div>                
                <div class="couponChk">
                  <!--<i class="fa fa-angle-right"></i>-->
				  <img src="/static/coupon/coupon_more.png" width="25" height="7">
                </div>
				<div class="couponValue">优惠<i class="fa fa-rmb"></i>{{platformCouponTotalMoney()}}</div>
              </div>              
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="price-info">
        <div class="row">
          <p class="title">商品金额</p>
          <p class="price">
            <i class="fa fa-rmb"></i>
            <span>{{totalPrice.toFixed(2)}}</span>
          </p>
        </div>
        <div class="row">
          <p class="title">运费</p>
          <p class="price">
            <span>+</span>
            <i class="fa fa-rmb"></i>
            <span>{{freightPrice}}</span>
          </p>
        </div>
        <div class="row">
          <p class="title">积分抵扣</p>
          <p class="price">
            <span>-</span>
            <i class="fa fa-rmb"></i>
            <span>{{integral}}.00</span>
          </p>
        </div>
        <div class="row">
          <p class="title">BAW抵扣</p>
          <p class="price">
            <span>-</span>
            <i class="fa fa-rmb"></i>
            <span>{{bawDiscountTotalPrice}}</span>
          </p>
        </div>
      </div> -->

      <mu-divider />
      <div class="bottom-bar">
        <mu-row >
          <mu-col width="65" tablet="65" desktop="65">
            <div class="cart-money">
              <p class="cart-total">
                <span>实付款：<i class="fa fa-rmb"></i></span>
                <span class="money">{{getAllOrderMoney().toFixed(2)}}</span>
              </p>
              <p class="cart-freightMoney">运费{{getAllOrderFreight().toFixed(2)}}</p>
            </div>
            <div class="cart-discount">
              <p>合计减：<i class="fa fa-rmb"></i>{{getAllOrderCouponMoney().toFixed(2)}}</p>
            </div>
          </mu-col>
          <mu-col width="35" tablet="35" desktop="35">
            <mu-flat-button :label="'提交订单'" class="gobuy" backgroundColor="red" color="white" fullWidth @click="orderSubmit" />
          </mu-col>
        </mu-row>
      </div>
      
      <!--选择送货方式-->
      <mu-popup position="bottom" popupClass="retailOrderSubmitpage-popupLayer delivery" :open="deliveryPopup" @close="closeDelivery()">
        <mu-sub-header >请选择送货方式</mu-sub-header>
        <div class="deliveryChoose">
          <template v-for="methodItem in shippingMethodList">
            <mu-raised-button :label="methodItem.method"  :class="currentShopDeliveryType == methodItem.Id ? 'shippingBtn select' : ''" @click="choseDeliveryTypeItemClick(methodItem.Id,methodItem.method)" :key="methodItem.Id" v-if="methodItem.Id == 1"></mu-raised-button>
          </template>
          <mu-raised-button label="自提" :class="currentShopDeliveryType == 3 ? 'shippingBtn select' : ''" @click="choseDeliveryTypeItemClick(3,'自提')" v-if="currentZitiService || currentZitiProduct"></mu-raised-button>
        </div>
        <mu-sub-header v-if="currentShopDeliveryType != 3">请选择送货时间</mu-sub-header>
        <div class="dateChoose">
          <div class="dateleft">
          </div>
        </div>
        <div class="deliveryChoose" v-if="currentShopDeliveryType != 3">
          <template v-for="dateItem in shippingDateList" >
            <mu-raised-button  :label="dateItem.method" :class="currentShopDeliveryDate == dateItem.Id ? 'shippingBtn select' : ''" @click="choseDeliveryDateItemClick(dateItem.Id,dateItem.method)" :key="dateItem.Id"></mu-raised-button>
          </template>
        </div>
        <mu-raised-button primary fullWidth class="delvieryChooseBtn" @click="choseDeliveryOK()" label="确定"/>
      </mu-popup>
      <!--选择自提时间-->
      <mu-popup position="bottom" popupClass="retailOrderSubmitpage-popupLayer bottom" :open="selfPickUpPopup" @close="closeSelfPickUpDate()">
        <mu-sub-header >请选择自提时间</mu-sub-header>
        <div class="dateChoose" >
          <div class="dateleft">
              <mu-raised-button :class="currentSelfPickUpDate1==day ? 'active':''" :label="day" v-for="day in selfPickUpDateList" :key="day" @click="choseSelfPickUpDateClick1(day)"></mu-raised-button>
          </div>
          <div class="daterigth">
              <mu-raised-button label="上午" :class="currentSelfPickUpDate2 == '上午'?'active':''" @click="choseSelfPickUpDateClick2('上午')"></mu-raised-button>
              <mu-raised-button label="下午" :class="currentSelfPickUpDate2 == '下午'?'active':''" @click="choseSelfPickUpDateClick2('下午')"></mu-raised-button>
          </div>
        </div>
        <mu-raised-button primary fullWidth class="delvieryChooseBtn" label="确定" @click="choseSelfPickUpDateOK" />
      </mu-popup>
      
      <!--选择店铺优惠券-->
      <mu-popup position="bottom" popupClass="retailOrderSubmitpage-popupLayer shopCoupon" :open="shopCouponPopup" @close="closeShopCoupon()">
        <div class="couponListTilte">店铺优惠</div>
        
        <div class="couponList">
          <div class="couponListItem" v-for="couponItem in currentShopUsefulCouponList.CouponUseItem" :key="couponItem.CouponNumber">
            <div class="couponIcon">
              <div class="couponIconContent">
                <p>通用券</p>
                <img src="/static/coupon/couponItemBg3.png" />
              </div>
            </div>
            <div class="couponValue" :style="{width: couponCenterWidth+'px'}">满{{couponItem.FullMoney}}减{{couponItem.Money}}元</div>
            <div class="couponOperator">
              <mu-checkbox class="cart-chk" :nativeValue="couponItem.CouponNumber" v-model="shopCouponCheckList" @change="checkBoxShopCoupon(couponItem.CouponNumber,couponItem.FullMoney, couponItem.Money)" uncheckIcon=":fa fa-circle-thin" checkedIcon=":fa fa-yes"/>
              <!-- <mu-icon value=":fa fa-circle" /> -->
            </div>
          </div>
		  <div class="couponListItem">
            <div class="couponIcon">
              <div class="couponIconContent">
                <p>通用券</p>
                <img src="/static/coupon/couponItemBg3.png" />
              </div>
            </div>
            <div class="couponValue" :style="{width: couponCenterWidth+'px'}">不使用店铺通用券</div>
            <div class="couponOperator">
              <mu-checkbox class="cart-chk" :nativeValue="0" v-model="shopCouponCheckList" @change="checkBoxShopCoupon(0,0,0)"  uncheckIcon=":fa fa-circle-thin" checkedIcon=":fa fa-yes"/>
              <!-- <mu-icon value=":fa fa-circle" /> -->
            </div>
          </div>
          <div class="couponListItem disabled" v-for="couponItem in currentShopUsefulCouponList.CouponNoUseItem" :key="couponItem.CouponNumber">
            <div class="couponIcon" @click="openErr(couponItem.Content)">
              <div class="couponIconContent">
                <p>通用券</p>
                <img src="/static/coupon/couponItemBg4.png" />
              </div>
            </div>
            <div class="couponValue" @click="openErr(couponItem.Content)" :style="{width: couponCenterWidth+'px'}">满{{couponItem.FullMoney}}减{{couponItem.Money}}元</div>
            <div class="couponOperator">
              <mu-checkbox class="cart-chk" disabled  uncheckIcon=":fa fa-circle-thin" checkedIcon=":fa fa-yes"/>
              <!-- <mu-icon value=":fa fa-circle" /> -->
            </div>
          </div>
        </div>

        <mu-raised-button primary fullWidth class="delvieryChooseBtn" @click="checkShopCoupon()" label="确定"/>
      </mu-popup>
      <!--选择平台优惠券-->
      <mu-popup position="bottom" popupClass="retailOrderSubmitpage-popupLayer platformCouponPopup" :open="platformCouponPopup" @close="closePlatformCoupon()" style="border-radius:15px">
		<div class="platformCouponListTilte">平台优惠券</div><div class="couponClose" @click="closePlatformCoupon()"><img src="/static/coupon/couponClose.png" width=25 height=25></div>        
        <div style="clear:both"></div>
		<mu-tabs :value="activeTab" @change="handleTabChange">
          <mu-tab value="1" :title="'可用优惠券'+'('+currentPlatformUsefulCouponList.CouponUseItem.length+')'"/>
		  <mu-tab value="2" :title="'不可用优惠券'+'('+currentPlatformUsefulCouponList.CouponNoUseItem.length+')'"/>
        </mu-tabs>
		<div class="platformCouponSelectMsg" :style="{width:selectMsgWidth + 'px'}">您已选中优惠券{{platformCouponCheckList.length}}张,可抵用<font style="color:#E62129"><i class="fa fa-rmb"></i>{{selPlatformCouponTotalMoney()}}</font></div>
		<div class="platformCouponBestBtn" @click="getBast">使用推荐优惠</div>
		<div style="clear:both;height:10px;"></div>
		<div style="height:280px;background:#F6F4F7;">
		<div class="platformCouponList">
		  <div class="couponListItem" v-for="couponItem in currentPlatformUsefulCouponList.CouponUseItem" :key="couponItem.CouponNumber" v-if="activeTab == 1">
		    <div class="platformCouponMoney">
			  <div class="keyongMoney">
			    <span class="MoneyCircle">
				  <p class="cost">￥</p>
                  <p class="money">{{couponItem.Money}}</p>
				</span>
			    <span class="FullMoney">满{{couponItem.FullMoney}}可用</span>
			  </div>
			</div>
			<div class="platformCouponSel" :style="{width:selPlatformWidth+'px'}">
			  <div class="dor"></div>
			  <div class="keyongSel" :style="{width:selPlatformWidth-10+'px'}">
				<div class="selContent"><span class="selType">{{EnumRangeType(couponItem.RangeType)}}</span>{{couponItem.Name}}<br><span class="selDate">{{couponItem.StartTime}}-{{couponItem.EndTime}}</span></div>
				<div class="selBtn"><mu-checkbox :disabled="loaded" class="cart-chk" :nativeValue="couponItem.CouponNumber" v-model="platformCouponCheckList" @change="checkBoxPlatformCoupon(couponItem.CouponNumber,couponItem.FullMoney,couponItem.Money)"  uncheckIcon=":fa fa-circle-thin" checkedIcon=":fa fa-yes"/></div>
			  </div>
			</div>
		  </div>		  
		  <div class="couponListItem" v-for="couponItem in currentPlatformUsefulCouponList.CouponNoUseItem" :key="couponItem.CouponNumber" v-if="activeTab == 2">
		    <div class="platformCouponMoney">
			  <div class="bukeyongMoney">
			    <span class="MoneyCircle">
				  <p class="cost">￥</p>
                  <p class="money">{{couponItem.Money}}</p>
				</span>
			    <span class="FullMoney">满{{couponItem.FullMoney}}可用</span>
			  </div>
			</div>
			<div class="platformCouponSel" :style="{width:selPlatformWidth+'px'}">
			  <div class="dor"></div>
			  <div class="bukeyongSel" :style="{width:selPlatformWidth-10+'px'}">
				<div class="selContent"><span class="selType">{{EnumRangeType(couponItem.RangeType)}}</span>{{couponItem.Name}}<br><span class="selDate">{{couponItem.StartTime}}-{{couponItem.EndTime}}</span></div>
				<div class="selBtn"><mu-checkbox class="cart-chk" disabled  uncheckIcon=":fa fa-circle-thin" checkedIcon=":fa fa-yes"/></div>
			  </div>
			</div>
		  </div>
		  <div style="clear:both;height:20px;"></div>
		</div>
		
		
		
		
		
        </div>
        <mu-raised-button primary fullWidth class="platformDelvieryChooseBtn" @click="checkPlatformCoupon()" label="确定"/>
      </mu-popup>
    </div>
    <XR-toast @onClose="submitSuccess" ref="XRtoast"></XR-toast>
  </div>
</template>

<script>
import cart from '../../util/cart'
export default {
  data () {
    return {
      fullWidth: (parseInt(document.documentElement.clientWidth)-20) ,
	  devWidth: (parseInt(document.documentElement.clientWidth)-170-20) ,
	  selectMsgWidth: (parseInt(document.documentElement.clientWidth)-146),
	  selPlatformWidth: (parseInt(document.documentElement.clientWidth)-114),
      cartItemProductInfoWidth: (parseInt(document.documentElement.clientWidth)-130),
      addressInfoWidth: (parseInt(document.documentElement.clientWidth)-100) ,
      chooseInfoWidth: (parseInt(document.documentElement.clientWidth)-180) ,  
      skuList:[],//SkuId及数量集合
      productInfoList:[], //商品信息集合
      productBawmoney:0,//baw金额集合
      showMoney:0,//最终显示的抵扣金额
      selfPickUpDateList: [], //自提时间生成
      candyRate : 100,  //BAW汇率(糖果)
      candyBalance: 0.00, //BAW账户余额(糖果)
      memberFinance: {
        Coin:0,
        Integral:0,
        Sun:0
      }, //会员账户信息
      shippingDateList:[], //发货时间列表
      shippingMethodList:[], //发货方式列表
      receiveAddress:{}, //收货地址信息

      deliveryPopup : false, //发货方式选择框
      selfPickUpPopup : false, //自提时间选择框
      fapiaoPopup : false, //发票选择框
      candyPopup : false, //BAW选择框(糖果)

      isFapiao: false, //是否有发票
      isCandy: false, //是否使用baw(糖果)
	  isDisabled: true, //是否禁用使用baw(糖果)

      candyErrorText:'', //BAW错误信息(糖果)
      multiLineInputErrorText:'',//留言错误信息
      
      currentShopId:'', //当前操作的店铺Id
      currentShopDeliveryType: 0, //发货方式选择框选中值
      currentShopDeliveryTypeName: '', //发货方式选择框选中值的名称
      currentShopDeliveryDate: 0, //发货时间选择框选中值
      currentShopDeliveryDateName: '', //发货时间选择框选中值的名称
      currentZitiService: false, //当前店铺是否支持自提商品
      currentZitiProduct:false, //当前店铺是否支持自提服务
      currentSelfPickUpDate1:'', //当前选择的自提日期
      currentSelfPickUpDate2:'', //当前选择的自提时间

      shopIds:[], //哪些店铺有可用优惠券的列表
      shopCouponPopup: false, //店铺优惠券控制显示
      platformCouponPopup: false, //平台优惠券控制显示
      
      shopCouponCheckList: [], //店铺优惠券选择
      couponCenterWidth: (parseInt(document.documentElement.clientWidth)-66-24-32), //选择优惠券行中间内容宽度
      platformCouponCenterWidth: (parseInt(document.documentElement.clientWidth)-60-80), //选择优惠券行中间内容宽度
      
      currentShopUsefulCouponShopId:'', //当前选择店铺优惠券的商家Id
      currentShopCouponInfo:{FullMoney:0, Money:0}, //当前选择店铺优惠券的信息
      currentShopUsefulCouponList:{
        CouponUseItem:[], //可用列表
        CouponNoUseItem:[] //不可用列表
      }, //店铺优惠券列表

      platformCouponCheckList: [], //平台优惠券选择
      currentPlatformCouponInfo:{FullMoney:0, Money:0}, //当前选择平台优惠券的信息
      currentPlatformRangeType:0, //选择的平台优惠券类型
      currentPlatformUsefulCouponList:{
        CouponUseItem:[], //可用列表
        CouponNoUseItem:[] //不可用列表
      }, //平台优惠券列表

      orderSubmitDto:{
        TwoOrderType:0,//默认值
        InvoiceHead:'',//发票
        addrId : '0', //收货地址，用于物流订单        
        isIntegral:false, //是否使用积分（保留字段）
        integral:0, //抵扣积分数（保留字段）
        isBaw:false, // 是否使用BAW抵扣
        baw:0.000000, //BAW抵扣额(糖果)
        platformCouponList:[], //使用的平台优惠券列表
        shopOrder:[{
          shopId:'', //店铺Id           
          productList:[], //商品列表
          shippingMethodId:0, //发货方式
          shippingDateId:0, //收货时间
          selfPickUpSiteShopId:'', //自提点
          selfPickUpDate:'', //自提时间
          couponNumber:'', //店铺优惠券编号
          mobile:'',//手机号
          remark:'' //留言,
        }] //店铺订单
      }, //订单提交数据

      HasPlatformCoupon1: false, //会员是否有可使用的平台商品券
      HasPlatformCoupon2: false, //会员是否有可使用的平台品类券
      HasPlatformCoupon0: false, //会员是否有可使用的平台通用券

      shopMoneyList:[], //店铺金额信息
      orderPayMoney:0, //订单总金额
	  activeTab:'1', //默认是可用优惠券
	  loaded:false,
      IsInvoice:0, //是否可以开发票
    }
  },
  mounted:function(){
    console.log(this.candyName);
    this.$refs.XRtoast.load()
    this.getSelftPickUpDate()
    this.getSkuList()
    this.getShippingDateList()
    this.getShippingMethodList()
    this.getDefaultAddress()	
  },
  methods: {
    //自提时间生成
    getSelftPickUpDate(){      
      var dateObj = new Date()
      for(var i = 0; i<5; i++){
        dateObj.setDate(dateObj.getDate()+1)

        var year = dateObj.getFullYear()
        var month = dateObj.getMonth()+1
        if(month<10){
          month= '0'+month
        }
        var day = dateObj.getDate()
        if(day<10){
          day= '0'+day
        }
        day = year +'-'+ month +'-' + day
        this.selfPickUpDateList.push(day)
      }
    },
    //获取商品列表
    //1、立即购买时，直接从地址栏获取商品
    //2、购物车结算时，从购物车里获取商品
    getSkuList(){
      this.skuList = []
      if(this.$route.query.skuId>0){
        this.skuList = [{skuId: this.$route.query.skuId, count:this.$route.query.count}]
      }
      else{
        this.skuList = cart.getSelectList()
      }
    },
    //留言超过50时自动提示
    handleMultiLineOverflow (isOverflow) {
      this.multiLineInputErrorText = isOverflow ? '不能超过50个字符' : ''
    },
    //查询默认收货地址
    getDefaultAddress(){
      var ths = this
      ths.$post(
        "/Shop/UserServer/GetDefaultReceiveAddress"
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)   
        }else{   
          ths.receiveAddress = res.Data
          ths.orderSubmitDto.addrId = res.Data.Id
        }
		ths.getCandyInfo()		
      });
      
    },
    //获取邮费
    getFreight(shopId, shippingMethodId,skus){
      if (this.receiveAddress.Province == null){
	    return
	  }
      var ths = this
	  if (shippingMethodId == 3){
	      for(var i = 0; i < ths.productInfoList.length; i++){
            if(ths.productInfoList[i].ShopId == shopId){
              ths.productInfoList[i].FreightMoney = 0
            }
          }

          var isAdd = false
          for(var i =0; i< ths.shopMoneyList.length;i++){
            if(ths.shopMoneyList[i].ShopId == shopId){
              ths.shopMoneyList[i].FreightMoney = 0
            }
          }
	    if(!isAdd){
              ths.shopMoneyList.push({ShopId:shopId, FreightMoney:0})
	    }
	    return
	  }
	  
      ths.$post(
        "/Shop/RetailServer/GetFreightByAddressCode",
        JSON.stringify({
          provinceCode:this.receiveAddress.Province,
          cityCode: this.receiveAddress.City,
          areaCode: this.receiveAddress.Area,
          shoppingMethod: shippingMethodId,
          skus: skus
        })
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{  
          //ths.freightPrice = res.Data
          for(var i = 0; i < ths.productInfoList.length; i++){
            if(ths.productInfoList[i].ShopId == shopId){
              ths.productInfoList[i].FreightMoney = res.Data
            }
          }

          var isAdd = false
          for(var i =0; i< ths.shopMoneyList.length;i++){
            if(ths.shopMoneyList[i].ShopId == shopId){
              ths.shopMoneyList[i].FreightMoney = res.Data
            }
          }
          if(!isAdd){
              ths.shopMoneyList.push({ShopId:shopId, FreightMoney:res.Data})
          }
        }
      });
    },
    getFreightCache(shopId){
      for(var i =0 ; i< this.shopMoneyList.length;i++){
        if(this.shopMoneyList[i].ShopId == shopId){
            return this.shopMoneyList[i].FreightMoney
          }
      }
      return 0
    },
    //获取购物车商品信息
    getProductList(){
      var ths = this
      
      var data = {skuIds:[]}
      for(var i =0; i< this.skuList.length ; i++){        
        data.skuIds.push(this.skuList[i].skuId)
      }
      if(data.skuIds.length ==0){
        ths.$refs.XRtoast.hide()
        ths.loaded = false
        return
      }

      ths.$post(
        "/Shop/RetailServer/GetCartProductList",
        JSON.stringify(data)
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{  
          var IsInvoice = 1;
          ths.orderSubmitDto.shopOrder = [];

          ths.productInfoList = res.Data
          for(var i=0; i< res.Data.length;i++){ 
            ths.productBawmoneyList=res.Data[i].Products
            var shopInfo = {shopId: ths.productInfoList[i].ShopId , productList:[] }

            if(ths.productInfoList[i].IsZiTiService && !ths.productInfoList[i].IsZitiProduct){
              ths.productInfoList[i].SelfPickUpInfo = {shopId: ths.productInfoList[i].ShopId, shopName: ths.productInfoList[i].ShopName, address :ths.productInfoList[i].ShopAddress}
			  window.localStorage[ths.productInfoList[i].ShopId + 'SelfPickUpShopInfo'] = JSON.stringify(ths.productInfoList[i].SelfPickUpInfo)
            }
              var deliveryInfo = ths.readSelfDeliveryUp(ths.productInfoList[i].ShopId)
              if (deliveryInfo.shippingMethodId > 0){
			    //成功读取到缓存，按缓存数据来
				if (deliveryInfo.shippingMethodId == 3){
				  //选择了自提
				  ths.productInfoList[i].SelfPickUpInfo = ths.readSelfPickUp(ths.productInfoList[i].ShopId)
				  if(ths.productInfoList[i].SelfPickUpInfo.shopId){
                    ths.productInfoList[i].DeliveryType = 3
					ths.productInfoList[i].SelfPickUpDate1 = deliveryInfo.SelfPickUpDate1
					ths.productInfoList[i].SelfPickUpDate2 = deliveryInfo.SelfPickUpDate2		
                  }
				  
				} else {
				  ths.productInfoList[i].DeliveryType = deliveryInfo.shippingMethodId
				  ths.productInfoList[i].DeliveryDate = deliveryInfo.shippingDateId
				  ths.productInfoList[i].DeliveryTypeName = deliveryInfo.DeliveryTypeName
				  ths.productInfoList[i].DeliveryDateName = deliveryInfo.DeliveryDateName
				}
				ths.productInfoList[i].Mobile = deliveryInfo.mobile		
				ths.productInfoList[i].Remark = deliveryInfo.remark		
			  }



            ths.productInfoList[i].TotalMoney =0.00
            ths.productInfoList[i].ShopCouponMoney =0.00
            ths.productInfoList[i].FreightMoney =0.00
            ths.productInfoList[i].CartCount =0 //店铺商品总数
			if (!ths.productInfoList[i].Remark){
			  ths.productInfoList[i].Remark = ''
			}
            for(var j =0 ; j< res.Data[i].Products.length;j++){
              if(res.Data[i].Products[j].IsInvoice == 0){
                IsInvoice = 0;
              }    
              if(res.Data[i].Products[j].State!=0){
                continue;
              }       
              var count = ths.getCartItemCount(res.Data[i].Products[j].SkuId)
              if(ths.$route.query.skuId>0){
                count=ths.$route.query.count
              }

              shopInfo.productList.push({skuId: res.Data[i].Products[j].SkuId, count : count})

              ths.productInfoList[i].TotalMoney += res.Data[i].Products[j].SalePrice * count
              ths.productInfoList[i].CartCount += parseInt(count)
              ths.orderPayMoney += ths.productInfoList[i].TotalMoney     
              ths.productBawmoney+=res.Data[i].Products[j].BawPrice * ths.candyRate * ths.getCartItemCount(res.Data[i].Products[j].SkuId)
            }
            ths.orderSubmitDto.shopOrder.push(shopInfo)
          }
          ths.IsInvoice = IsInvoice;
          if(ths.productBawmoney<=0)
          {
            ths.isCandy=false
          }
          if(ths.candyBalance>=ths.productBawmoney)
          {
            ths.showMoney=ths.productBawmoney
          }else
          {
            ths.showMoney=ths.candyBalance
          }
		  if (ths.showMoney > 0){
		    ths.isCandy = true
			ths.isDisabled = false
		  }          
          ths.$refs.XRtoast.hide()
          ths.loaded = false
		  
		  
		  
		  //批量重新获取邮费
		  for(var i = 0; i< ths.productInfoList.length; i++){
		    if (ths.productInfoList[i].DeliveryType > 0){
			  if (ths.productInfoList[i].DeliveryType == 3){
			    continue
			  }
		      var skuIds = []
		      for(var j = 0; j< ths.productInfoList[i].Products.length;j++){
		        skuIds.push({skuId : ths.productInfoList[i].Products[j].SkuId.toString(), count: parseInt(ths.getCartItemCount(ths.productInfoList[i].Products[j].SkuId))})
		      }            
		      ths.getFreight(ths.productInfoList[i].ShopId,ths.productInfoList[i].DeliveryType, skuIds)
			}
		  }
		  
		  		  
		  
		  //判断有没有优惠券使用的缓存，如果没有，应用优惠券最优叠加方案
		  var cache = ths.readSelfCouponUp()
		  console.log(ths.$route.query)
		  if (ths.$route.query.skuId || ths.$route.query.fromUrl == "/retail/cart"){
		    ths.getBestCoupon()
		  } else {
			//商家通用券
			for(var i = 0; i < ths.orderSubmitDto.shopOrder.length;i++){
				for(var j = 0; j < cache.storeCouponList.length;j++){
					if(ths.orderSubmitDto.shopOrder[i].shopId == cache.storeCouponList[j].ShopId){
						ths.orderSubmitDto.shopOrder[i].couponNumber = cache.storeCouponList[j].CouponNumber
						ths.orderSubmitDto.shopOrder[i].FullMoney = cache.storeCouponList[j].FullMoney
						ths.orderSubmitDto.shopOrder[i].Money = cache.storeCouponList[j].Money
						for(var k = 0; k < ths.productInfoList.length;k++){
							if(ths.productInfoList[k].ShopId == cache.storeCouponList[j].ShopId){
								ths.productInfoList[k].couponInfo = '满'+cache.storeCouponList[j].FullMoney+'减'+cache.storeCouponList[j].Money+'元'
								ths.productInfoList[k].ShopCouponMoney = cache.storeCouponList[j].Money
								break
							}
						}
						break
					}
				}				
			}			
			
			//平台券
			ths.orderSubmitDto.platformCouponList = cache.platformCouponList
			ths.getMyCouponList()
      }
      }
      });
    },    
    //获取发货时间列表
    getShippingDateList(){
      var ths = this  
      ths.$post(
        "/Shop/RetailServer/GetShippingDateList"
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{    
          ths.shippingDateList = res.Data
        }
      });
    },
    //获取发货方式列表
    getShippingMethodList(){   
      var ths = this 
      ths.$post(
        "/Shop/RetailServer/GetShippingMethodList"
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{  
          ths.shippingMethodList = res.Data
        }
      });
    },
    //获取会员账户信息
    // getMemberFinance(){
    //   var ths = this;
    //   this.$post(
    //     "/Shop/UserServer/GetMemberFinanceAccount"
    //   ).then(function(res) {
    //     if(res.IsSuccess){          
    //       ths.memberFinance = res.Data;
    //     }else{
    //       ths.$refs.XRtoast.failed(res.Msg, true)
    //     }
    //   });
    // },
    //获取BAW账户余额信息
    getCandyInfo: function () {    
      const ths = this;
      this.$post('/Shop/' + this.candyName + 'Server/Get' + this.candyName + 'AccountInfo')
        .then(function (res) {
          if(res.IsSuccess){
            ths.candyBalance = res.Data.Coin
          }
          ths.getCandyRate()		  
        })
        .catch(function (err) {
		  ths.getCandyRate()
          console.log(err)
        })    
    }, 
    //查询BAW汇率  
    getCandyRate: function () {    
      const ths = this;
      this.$post('/Shop/' + this.candyName + 'Server/Get' + this.candyName + 'ByRMB', {"rmb": 1})
        .then(function (res) {
          if(res.IsSuccess){
            ths.candyRate = res.Data
          }
          ths.getProductList()	
        })
        .catch(function (err) {
          console.log(err)
        })    
    }, 
    //打开发货方式选择框
    choseDelivery(shopId, cartCount){
      this.currentShopId = shopId
      this.currentShopDeliveryType = 0
      this.currentShopDeliveryTypeName = ''
      this.currentShopDeliveryDate = 0
      this.currentShopDeliveryDateName = ''
      this.currentZitiService = false
      this.currentZitiProduct = false

      this.deliveryPopup = true
      for(var i = 0; i< this.productInfoList.length; i++){
        if(this.productInfoList[i].ShopId != shopId){
          continue
        }
        if(this.productInfoList[i].DeliveryType){
          this.currentShopDeliveryType = this.productInfoList[i].DeliveryType
        }
        if(this.productInfoList[i].DeliveryDate){
          this.currentShopDeliveryDate = this.productInfoList[i].DeliveryDate
        }
        if(cartCount==1){
          if(this.productInfoList[i].IsZiTiService){
            this.currentZitiService = this.productInfoList[i].IsZiTiService
          }
          if(this.productInfoList[i].IsZitiProduct){
            this.currentZitiProduct = this.productInfoList[i].IsZitiProduct
          }
        } else {
          if(this.productInfoList[i].IsZiTiService){
            this.currentZitiService = this.productInfoList[i].IsZiTiService
          }
		  //判断只要有一个产品不支持自提，就不支持自提
		  var currentZitiProduct = true
		  for(var j = 0; j< this.productInfoList[i].Products.length; j++){
			if (this.productInfoList[i].Products[j].IsZiTi == false){
				currentZitiProduct = false
				break;
			}
		  }
		  this.currentZitiProduct = currentZitiProduct
		}
      }
    },
    //发货方式单选点击事件
    choseDeliveryTypeItemClick(deliveryTypeId, deliveryTypeName){
      this.currentShopDeliveryType = deliveryTypeId
      this.currentShopDeliveryTypeName =  deliveryTypeName
	  
    },
    //发货时间单选点击事件
    choseDeliveryDateItemClick(deliveryDateId, deliveryDateName){
      this.currentShopDeliveryDate = deliveryDateId
      this.currentShopDeliveryDateName =  deliveryDateName
    },
    //选择发货方式确定
    choseDeliveryOK(){	  
      if(this.currentShopDeliveryType<=0){
        this.$refs.XRtoast.failed('请选择发货方式', true)
        return
      }
	  
	  console.log("this.currentShopId:" + this.currentShopId)
	  
	  //保存缓存
	  var json = {shippingMethodId: this.currentShopDeliveryType, DeliveryTypeName: this.currentShopDeliveryTypeName}
	  this.saveSelfDeliveryUp(this.currentShopId, json);
		  
      if(this.currentShopDeliveryType == 3){        
        for(var i = 0; i< this.productInfoList.length; i++){
          if(this.productInfoList[i].ShopId != this.currentShopId){
            continue
          }
          
		  
		  

          if(!this.productInfoList[i].IsZitiProduct && this.productInfoList[i].IsZiTiService){  //本店自提
        console.log("本店自提")
        
        this.$refs.XRtoast.failed('仅限本店自提', true)


            this.deliveryPopup = false
			
			this.productInfoList[i].DeliveryType = this.currentShopDeliveryType
			if (this.currentShopDeliveryTypeName != ""){
			  this.productInfoList[i].DeliveryTypeName = this.currentShopDeliveryTypeName
			}
		  
		  if (this.currentShopDeliveryType == 3){
	      for(var i = 0; i < this.productInfoList.length; i++){
            if(this.productInfoList[i].ShopId == this.currentShopId){
              this.productInfoList[i].FreightMoney = 0
            }
          }

          var isAdd = false
          for(var i =0; i< this.shopMoneyList.length;i++){
            if(this.shopMoneyList[i].ShopId == this.currentShopId){
              this.shopMoneyList[i].FreightMoney = 0
            }
          }
	    if(!isAdd){
              this.shopMoneyList.push({ShopId:this.currentShopId, FreightMoney:0})
	    }
	  }
		  
		  
		  
		  
			//保存缓存
			var json = {shippingMethodId: this.currentShopDeliveryType, DeliveryTypeName: this.currentShopDeliveryTypeName}
			this.saveSelfDeliveryUp(this.currentShopId, json);
            return
          }
        }
        this.goToSelfPickUp(this.currentShopId)
		
		this.productInfoList[i].DeliveryType = this.currentShopDeliveryType
		  if (this.currentShopDeliveryTypeName != ""){
            this.productInfoList[i].DeliveryTypeName = this.currentShopDeliveryTypeName
		  }
		//保存缓存
		var json = {shippingMethodId: this.currentShopDeliveryType, DeliveryTypeName: this.currentShopDeliveryTypeName}
		this.saveSelfDeliveryUp(this.currentShopId, json);
        return
      }



      if(this.currentShopDeliveryDate<=0){
        this.$refs.XRtoast.failed('请选择发货时间', true)
        return
      }
	  
	  //保存缓存
	  var json = {shippingDateId: this.currentShopDeliveryDate, DeliveryDateName: this.currentShopDeliveryDateName}
	  this.saveSelfDeliveryUp(this.currentShopId, json);
	  
      this.deliveryPopup = false
      for(var i = 0; i< this.productInfoList.length; i++){
        if(this.productInfoList[i].ShopId != this.currentShopId){
          continue
        }

        var skuIds = []
        for(var j = 0; j< this.productInfoList[i].Products.length;j++){
          skuIds.push({skuId : this.productInfoList[i].Products[j].SkuId.toString(), count: parseInt(this.getCartItemCount(this.productInfoList[i].Products[j].SkuId))})
        }
        this.productInfoList[i].DeliveryType = this.currentShopDeliveryType
		if (this.currentShopDeliveryTypeName != ""){
		  this.productInfoList[i].DeliveryTypeName = this.currentShopDeliveryTypeName
		}
        this.productInfoList[i].DeliveryDate = this.currentShopDeliveryDate
		if (this.currentShopDeliveryDateName != ""){
		  this.productInfoList[i].DeliveryDateName = this.currentShopDeliveryDateName
		}        
        this.getFreight(this.productInfoList[i].ShopId,this.productInfoList[i].DeliveryType, skuIds)
      }

    },
    //关闭发货方式选择框
    closeDelivery(){
      this.deliveryPopup = false
    },
    //跳转到选择自提点页面
    goToSelfPickUp(shopId){
      for(var i = 0; i < this.productInfoList.length;i++){
        if(this.productInfoList[i].ShopId != shopId){
          continue;
        }
        if(!this.productInfoList[i].IsZiTiService && !this.productInfoList[i].IsZitiProduct){          
          if(!this.productInfoList[i].IsZiTiService){
            this.$refs.XRtoast.failed('商品不支持自提', true)
            return
          }
          if(!this.productInfoList[i].IsZitiProduct){
            this.$refs.XRtoast.failed('店铺不支持自提', true)
            return
          }        
        }
        if(this.productInfoList[i].Products.length!=1){  
          this.$refs.XRtoast.failed('仅支持单品自提', true)
          return          
        }
        this.$router.push('/retail/selectSelfPickUp?skuId='+this.productInfoList[i].Products[0].SkuId + '&shopId='+this.productInfoList[i].ShopId)
      }
    },
    //读取自提点缓存
    readSelfPickUp(shopId){
      var selfPickUpShop = window.localStorage[shopId+ 'SelfPickUpShopInfo']
      if(!selfPickUpShop){
        selfPickUpShop = {shopId: '', shopName: '', address:''}
      }else {
        selfPickUpShop = JSON.parse(selfPickUpShop)
      }
      return selfPickUpShop
    },
    //读取优惠券缓存
    readSelfCouponUp(){
      var SelfCouponUp = window.localStorage['SelfCouponUpInfo']
      if(!SelfCouponUp){
        SelfCouponUp = {storeCouponList: [], platformCouponList: []}
      }else {
        SelfCouponUp = JSON.parse(SelfCouponUp)
      }
      return SelfCouponUp
    },
	//读取其他物流信息缓存
    readSelfDeliveryUp(shopId){
      var selfDeliveryUpShop = window.localStorage[shopId+ 'SelfDeliveryUpShopInfo']
      if(!selfDeliveryUpShop){
        //selfDeliveryUpShop = {shippingMethodId: 0, shippingDateId: 0, DeliveryTypeName:'', DeliveryDateName:'', SelfPickUpDate1:'', SelfPickUpDate2:'', remark:''}
        selfDeliveryUpShop = {"shippingMethodId":1,"shippingDateId":3,"DeliveryTypeName":"物流公司送货","DeliveryDateName":"无限制，什么时候送都可以","SelfPickUpDate1":"","SelfPickUpDate2":"","remark":""}
		var ShopIds = window.localStorage['SelfShopIdUpInfo']
		if (!ShopIds){
		  var ShopIds = []
		  ShopIds.push(shopId)
		  window.localStorage['SelfShopIdUpInfo'] = JSON.stringify({ShopIds: ShopIds})
		} else {
		  ShopIds = JSON.parse(ShopIds)
		  ShopIds.ShopIds.push(shopId)
		  window.localStorage['SelfShopIdUpInfo'] = JSON.stringify(ShopIds)
		}
		window.localStorage[shopId+ 'SelfDeliveryUpShopInfo'] = JSON.stringify(selfDeliveryUpShop)
      }else {
        selfDeliveryUpShop = JSON.parse(selfDeliveryUpShop)
      }
      return selfDeliveryUpShop
    },
	//保存其他物流信息缓存
	saveSelfDeliveryUp(shopId, json){
	  var selfDeliveryUpShop = window.localStorage[shopId+ 'SelfDeliveryUpShopInfo']
	  if(!selfDeliveryUpShop){
		selfDeliveryUpShop = {shippingMethodId: 0, shippingDateId: 0, DeliveryTypeName:'', DeliveryDateName:'', SelfPickUpDate1:'', SelfPickUpDate2:'', remark:''}
	  } else {
	    selfDeliveryUpShop = JSON.parse(selfDeliveryUpShop)
	  }
	  if (json.shippingMethodId){
	    selfDeliveryUpShop.shippingMethodId = json.shippingMethodId
	  }
	  if (json.shippingDateId){
	    selfDeliveryUpShop.shippingDateId = json.shippingDateId
	  }
	  if (json.DeliveryTypeName){
	    selfDeliveryUpShop.DeliveryTypeName = json.DeliveryTypeName
	  }
	  if (json.DeliveryDateName){
	    selfDeliveryUpShop.DeliveryDateName = json.DeliveryDateName
	  }
	  if (json.SelfPickUpDate1){
	    selfDeliveryUpShop.SelfPickUpDate1 = json.SelfPickUpDate1
	  }
	  if (json.SelfPickUpDate2){
	    selfDeliveryUpShop.SelfPickUpDate2 = json.SelfPickUpDate2
	  }
	  if (json.mobile){
	    selfDeliveryUpShop.mobile = json.mobile
	  }
	  if (json.remark){
	    selfDeliveryUpShop.remark = json.remark
	  }
	  window.localStorage[shopId+ 'SelfDeliveryUpShopInfo'] = JSON.stringify(selfDeliveryUpShop)
	},
	//保存联系电话信息
    saveMobile(index){
	  //保存缓存
	  var json = {mobile: this.productInfoList[index].Mobile}
	  this.saveSelfDeliveryUp(this.productInfoList[index].ShopId, json);
	},
	//保存留言信息
    saveRemark(index){
	  console.log(this.productInfoList[index].ShopId)
	  //保存缓存
	  var json = {remark: this.productInfoList[index].Remark}
	  this.saveSelfDeliveryUp(this.productInfoList[index].ShopId, json);
	},
    //打开自提时间选择弹框
    openSelfPickUpDatePopup(shopId){
      this.currentShopId = shopId
      
      this.selfPickUpPopup = true      
      for(var i = 0; i< this.productInfoList.length; i++){
        if(this.productInfoList[i].ShopId != shopId){
          continue
        }
        if(this.productInfoList[i].SelfPickUpDate1){
          this.currentSelfPickUpDate1 = this.productInfoList[i].SelfPickUpDate1
          this.currentSelfPickUpDate2 = this.productInfoList[i].SelfPickUpDate2
        }
      }
    },
    //选择自提具体天数
    choseSelfPickUpDateClick1(day){
      this.currentSelfPickUpDate1 = day
    },
    //选择自提具体时间
    choseSelfPickUpDateClick2(date){
      this.currentSelfPickUpDate2 = date
    },
    //确定选择自提时间
    choseSelfPickUpDateOK(){
      if(!this.currentSelfPickUpDate1){
        this.$refs.XRtoast.failed("请选择天数", true)
        return
      }
      if(!this.currentSelfPickUpDate2){
        this.$refs.XRtoast.failed("请选择时间", true)
        return
      }
	  
	  
     
      for(var i = 0; i< this.productInfoList.length; i++){
        if(this.productInfoList[i].ShopId != this.currentShopId){
          continue
        }
        this.productInfoList[i].SelfPickUpDate1 = this.currentSelfPickUpDate1
        this.productInfoList[i].SelfPickUpDate2 = this.currentSelfPickUpDate2
		//保存缓存
		var json = {SelfPickUpDate1: this.currentSelfPickUpDate1, SelfPickUpDate2: this.currentSelfPickUpDate2}
		this.saveSelfDeliveryUp(this.currentShopId, json);
      }

      this.closeSelfPickUpDate()
    },
    //关闭选择自提时间
    closeSelfPickUpDate(){
      this.selfPickUpPopup = false   
      
      this.currentShopId = ''
      this.currentSelfPickUpDate1 = ''
      this.currentSelfPickUpDate2 = ''
    },	
	openErr(into){
      this.$refs.XRtoast.failed(into, true)
    },
    //查询可用的店铺优惠券
    getShopUsefulCouponList(shopId){  
      var skuIds = [];
      for(var i = 0; i< this.productInfoList.length;i++){
        for(var j = 0; j < this.productInfoList[i].Products.length;j++){
          var skuId = this.productInfoList[i].Products[j].SkuId
          var count = this.getCartItemCount(skuId)
          skuIds.push({skuId:skuId,  count:count , activityType:0})
        }
      }  
      var couponChooseList = []
      for(var i = 0; i< this.orderSubmitDto.shopOrder.length;i ++){
        if(this.orderSubmitDto.shopOrder[i].couponNumber){
          couponChooseList.push(this.orderSubmitDto.shopOrder[i].couponNumber)
        }
      }
      for(var i = 0; i < this.orderSubmitDto.platformCouponList.length;i++){
		couponChooseList.push(this.orderSubmitDto.platformCouponList[i].couponNumber)		
      }
      const ths = this;
      this.$post('/Shop/CouponServer/WapCouponUseList', { SkuIds: skuIds, Baw: 0, CouponNumbers: couponChooseList, shopId: shopId, rangeType: 0})
        .then(function (res) {
          if(res.IsSuccess){
            ths.currentShopUsefulCouponList = res.Data
            for(var i = 0; i < ths.orderSubmitDto.shopOrder.length; i++){
              if(ths.orderSubmitDto.shopOrder[i].shopId == shopId){
                if(ths.orderSubmitDto.shopOrder[i].couponNumber){
                  ths.shopCouponCheckList = [ths.orderSubmitDto.shopOrder[i].couponNumber]
				  console.log(ths.orderSubmitDto.shopOrder[i])
				  break;
				  
                }
              }
            }
			console.log(ths.currentShopUsefulCouponList.CouponUseItem)
			var isFind = false
			if (ths.shopCouponCheckList.length == 1){
				for(var i = 0; i < ths.currentShopUsefulCouponList.CouponUseItem.length; i++){
					if (ths.shopCouponCheckList[0] == ths.currentShopUsefulCouponList.CouponUseItem[i].CouponNumber){
						ths.currentShopCouponInfo.FullMoney = ths.currentShopUsefulCouponList.CouponUseItem[i].FullMoney
						ths.currentShopCouponInfo.Money = ths.currentShopUsefulCouponList.CouponUseItem[i].Money
						isFind = true
						break;
					}
				}
			}
			if (!isFind){
				console.log(ths.productInfoList)
				ths.shopCouponCheckList = []
				ths.currentShopCouponInfo.FullMoney = 0
				ths.currentShopCouponInfo.Money = 0
				for(var i = 0; i < ths.orderSubmitDto.shopOrder.length; i++){
					if(ths.orderSubmitDto.shopOrder[i].shopId == shopId){
						ths.orderSubmitDto.shopOrder[i].couponNumber = ""						
						break
					}
				}
				for(var i = 0; i < ths.productInfoList.length; i++){
					if(ths.productInfoList[i].ShopId == shopId){
						ths.productInfoList[i].ShopCouponMoney = 0
						ths.productInfoList[i].couponInfo = ""
						break
					}
				}
			}
			ths.getMyCouponList()			
          }       
          ths.shopCouponPopup = true 
        })
        .catch(function (err) {
          console.log(err)
        })    
    },
    //弹出店铺优惠券选择
    openShopCoupon(shopId, productList){
      this.currentShopUsefulCouponShopId = shopId
	  /**
      var skuIds = [];
      for(var i = 0; i< productList.length;i++){
        var skuId = productList[i].SkuId
        var count = this.getCartItemCount(skuId)
        skuIds.push({skuId:skuId,  count:count , activityType:0})
      }
	  **/
      this.getShopUsefulCouponList(shopId)
    },
    //选中店铺优惠券(门槛，优惠金额)
    checkBoxShopCoupon(couponNumber ,fullMoney, couponMoney){
      if(!this.shopCouponCheckList || this.shopCouponCheckList[0] != couponNumber){
        this.shopCouponCheckList = [couponNumber]
      }
      this.currentShopCouponInfo.FullMoney =  fullMoney
      this.currentShopCouponInfo.Money = couponMoney
    },
    //确定选择店铺优惠券
    checkShopCoupon(){
	  console.log(this.shopCouponCheckList)
      if(this.shopCouponCheckList.length ==0){
	    this.$refs.XRtoast.failed('您还未选择优惠券', true)
        return
	    /**
        for(var i = 0; i < this.orderSubmitDto.shopOrder.length;i++){
          if(this.orderSubmitDto.shopOrder[i].shopId == this.currentShopUsefulCouponShopId){
            this.orderSubmitDto.shopOrder[i].couponNumber = ''
			this.orderSubmitDto.shopOrder[i].FullMoney = 0
			this.orderSubmitDto.shopOrder[i].Money = 0
          }
        }
        for(var i = 0; i < this.productInfoList.length;i++){
          if(this.productInfoList[i].ShopId == this.currentShopUsefulCouponShopId){
            this.productInfoList[i].couponInfo = '请选择'
            this.productInfoList[i].ShopCouponMoney = 0
          }
        }
		**/		
      }else{
        if (this.shopCouponCheckList[0] == "0"){
			//不使用店铺优惠券
			for(var i = 0; i < this.orderSubmitDto.shopOrder.length;i++){
			  if(this.orderSubmitDto.shopOrder[i].shopId == this.currentShopUsefulCouponShopId){
			    this.orderSubmitDto.shopOrder[i].couponNumber = ''
			    this.orderSubmitDto.shopOrder[i].FullMoney = 0
			    this.orderSubmitDto.shopOrder[i].Money = 0
			  }
			}
			for(var i = 0; i < this.productInfoList.length;i++){
			  if(this.productInfoList[i].ShopId == this.currentShopUsefulCouponShopId){
			    this.productInfoList[i].couponInfo = '请选择'
			    this.productInfoList[i].ShopCouponMoney = 0
			  }
			}
			this.getMyCouponList()
			this.closeShopCoupon()
			return
		}
      
        for(var i = 0; i < this.orderSubmitDto.shopOrder.length;i++){
          if(this.orderSubmitDto.shopOrder[i].shopId == this.currentShopUsefulCouponShopId){
            this.orderSubmitDto.shopOrder[i].couponNumber = this.shopCouponCheckList.join(',')
			this.orderSubmitDto.shopOrder[i].FullMoney = this.currentShopCouponInfo.FullMoney
			this.orderSubmitDto.shopOrder[i].Money = this.currentShopCouponInfo.Money
          }
        }
        for(var i = 0; i < this.productInfoList.length;i++){
          if(this.productInfoList[i].ShopId == this.currentShopUsefulCouponShopId){
            this.productInfoList[i].couponInfo = '满'+this.currentShopCouponInfo.FullMoney+'减'+this.currentShopCouponInfo.Money+'元'
            this.productInfoList[i].ShopCouponMoney = this.currentShopCouponInfo.Money
          }
        }
      }
      //console.info(this.productInfoList)
	  //清空平台优惠券
	  this.orderSubmitDto.platformCouponList = []
	  this.getMyCouponList()
      //this.initPlatformCouponChoose()
	  
	  /**
      this.getPlatformUsefulCouponList(1,false,function(ths){
        if(!ths.HasPlatformCoupon1){
          ths.getPlatformUsefulCouponList(2,false, function(ths){
            if(!ths.HasPlatformCoupon2){
              ths.getPlatformUsefulCouponList(0,false)
            }
          })
        }
      })**/
      this.closeShopCoupon()
    },
    //关闭店铺优惠券选择
    closeShopCoupon(){
      this.currentShopUsefulCouponShopId = ''
      this.currentShopCouponInfo.FullMoney=0
      this.currentShopCouponInfo.Money=0
      this.shopCouponCheckList = []

      this.shopCouponPopup = false
    },	
	//查询我领的支持的优惠券
    getMyCouponList(){
		var cache = {storeCouponList: [], platformCouponList: []}
		var skuIds = [];
		for(var i = 0; i< this.productInfoList.length;i++){
			for(var j = 0; j < this.productInfoList[i].Products.length;j++){
				var skuId = this.productInfoList[i].Products[j].SkuId
				var count = this.getCartItemCount(skuId)
				skuIds.push({skuId:skuId,  count:count , activityType:0})
			}
		}
		var couponChooseList = []
		for(var i = 0; i< this.orderSubmitDto.shopOrder.length;i ++){
			if(this.orderSubmitDto.shopOrder[i].couponNumber){
				couponChooseList.push(this.orderSubmitDto.shopOrder[i].couponNumber)
				var tempStoreCoupon = {ShopId:this.orderSubmitDto.shopOrder[i].shopId, CouponNumber:this.orderSubmitDto.shopOrder[i].couponNumber, FullMoney:this.orderSubmitDto.shopOrder[i].FullMoney, Money:this.orderSubmitDto.shopOrder[i].Money }
				cache.storeCouponList.push(tempStoreCoupon)
			}
		}
		
		/**
		var SelPlatformCoupon1 = false
		var SelPlatformCoupon2 = false
		var SelPlatformCoupon0 = false
		for(var i = 0; i < this.orderSubmitDto.platformCouponList.length;i++){
			couponChooseList.push(this.orderSubmitDto.platformCouponList[i].couponNumber)
			if (this.orderSubmitDto.platformCouponList[i].rangeType == 1){
				SelPlatformCoupon1 = true
			}
			if (this.orderSubmitDto.platformCouponList[i].rangeType == 2){
				SelPlatformCoupon2 = true
			}
			if (this.orderSubmitDto.platformCouponList[i].rangeType == 0){
				SelPlatformCoupon0 = true
			}
		}
		**/
		
		//重新将优惠券放入缓存
		cache.platformCouponList = this.orderSubmitDto.platformCouponList
		window.localStorage['SelfCouponUpInfo'] = JSON.stringify(cache)
		
		
		const ths = this;
		this.$post('/Shop/CouponServer/WapPlatformCouponType', { SkuIds: skuIds, Baw: 0, CouponNumbers: couponChooseList})
			.then(function (res) {
				if(res.IsSuccess){
					ths.shopIds = []
					for (var i=0;i<res.Data.ShopIds.length;i++){
						ths.shopIds[res.Data.ShopIds[i]] = true
					}
					
					if (res.Data.ProductCoupon > 0 || res.Data.CategroyCoupon > 0 || res.Data.AllCoupon > 0){
						ths.HasPlatformCoupon0 = true
					} else {
						ths.HasPlatformCoupon0 = false
					}
					
					ths.loaded = false
					
					/**
					if (res.Data.ProductCoupon > 0){
						ths.HasPlatformCoupon1 = true
					} else {
						if (res.Data.CategroyCoupon > 0){
							ths.HasPlatformCoupon2 = true
						} else {
							if (res.Data.AllCoupon > 0){
								console.log("ths.HasPlatformCoupon0 = true")
								ths.HasPlatformCoupon0 = true
							}
						}
					}
					if (SelPlatformCoupon0){
						ths.HasPlatformCoupon0 = true
					}
					if (SelPlatformCoupon2){
						ths.HasPlatformCoupon2 = true
						if (res.Data.AllCoupon > 0){
							ths.HasPlatformCoupon0 = true
						}
					} else {
						if (!SelPlatformCoupon0 && res.Data.CategroyCoupon > 0){							
							ths.HasPlatformCoupon0 = false
						}
					}
					if (SelPlatformCoupon1){
						ths.HasPlatformCoupon1 = true
						if (res.Data.CategroyCoupon > 0){
							ths.HasPlatformCoupon2 = true
						} else {
							if (res.Data.AllCoupon > 0){
								ths.HasPlatformCoupon0 = true
							}
						}
					} else {
						if (res.Data.ProductCoupon > 0){
							ths.HasPlatformCoupon1 = true
							if (!SelPlatformCoupon2){
								ths.HasPlatformCoupon2 = false
							}
							if (!SelPlatformCoupon0){
								ths.HasPlatformCoupon0 = false
							}
						}
					}
					**/
				}				
			})
			.catch(function (err) {
			console.log(err)
		})
		
	},
	//优惠券最佳叠加方案
    getBestCoupon(){
		if (this.closeCoupon){
		  return
		}
		var skuIds = [];
		for(var i = 0; i< this.productInfoList.length;i++){
			for(var j = 0; j < this.productInfoList[i].Products.length;j++){
				var skuId = this.productInfoList[i].Products[j].SkuId
				var count = this.getCartItemCount(skuId)
				skuIds.push({skuId:skuId,  count:count , activityType:0})
			}
		}
		const ths = this;
		this.$post('/Shop/CouponServer/WapBestCoupon', { SkuIds: skuIds, Baw: 0})
			.then(function (res) {
				console.log(res)
				if(res.IsSuccess){
					for (var n=0;n<res.Data.CouponItem.length;n++){
						if (res.Data.CouponItem[n].Type == 1){
							//商家通用券
							for(var i = 0; i < ths.orderSubmitDto.shopOrder.length;i++){
								if(ths.orderSubmitDto.shopOrder[i].shopId == res.Data.CouponItem[n].ShopId){
									ths.orderSubmitDto.shopOrder[i].couponNumber = res.Data.CouponItem[n].CouponNumber
									ths.orderSubmitDto.shopOrder[i].FullMoney = res.Data.CouponItem[n].FullMoney
									ths.orderSubmitDto.shopOrder[i].Money = res.Data.CouponItem[n].Money
									break
								}
							}
							for(var i = 0; i < ths.productInfoList.length;i++){
								if(ths.productInfoList[i].ShopId == res.Data.CouponItem[n].ShopId){
									ths.productInfoList[i].couponInfo = '满'+res.Data.CouponItem[n].FullMoney+'减'+res.Data.CouponItem[n].Money+'元'
									ths.productInfoList[i].ShopCouponMoney = res.Data.CouponItem[n].Money
								}
							}
						} else if (res.Data.CouponItem[n].Type == 0){
							//平台券
							var platformCouponItem = {rangeType: res.Data.CouponItem[n].RangeType, couponNumber: res.Data.CouponItem[n].CouponNumber,'info': {FullMoney:res.Data.CouponItem[n].FullMoney, Money: res.Data.CouponItem[n].Money}}
							ths.orderSubmitDto.platformCouponList.push(platformCouponItem)
						}
					}
				}
				ths.getMyCouponList()
			})
			.catch(function (err) {
			ths.getMyCouponList()
			console.log(err)
		})	
	},
	//转换平台券累计优惠
    platformCouponTotalMoney(){
	  var totalMoney = 0
	  for(var i = 0; i < this.orderSubmitDto.platformCouponList.length;i++){
	    totalMoney+=this.orderSubmitDto.platformCouponList[i].info.Money
	  }
	  return totalMoney.toFixed(2)
	},
	//转换已选择平台券优惠
    selPlatformCouponTotalMoney(){
	  var totalMoney = 0
	  for(var i = 0; i < this.currentPlatformUsefulCouponList.CouponUseItem.length;i++){
	    for (var j=0;j<this.platformCouponCheckList.length;j++){
		  if (this.currentPlatformUsefulCouponList.CouponUseItem[i].CouponNumber == this.platformCouponCheckList[j]){
		    totalMoney+=this.currentPlatformUsefulCouponList.CouponUseItem[i].Money
		  }
		}
	  }
	  return totalMoney.toFixed(2)
	},
	//转换平台优惠券类型
    EnumRangeType(RangeType){
	  if (RangeType == 0){
	    return "平台通用券";
	  } else if (RangeType == 1){
	    return "平台商品券";
	  } else if (RangeType == 2){
	    return "平台分类券";
	  }
	},
	//查询我选的优惠券支持的平台优惠券
    getSelectPlatformUsefulCouponList(){
      if (this.closeCoupon){
        return
      }
      var skuIds = [];
      for(var i = 0; i< this.productInfoList.length;i++){
        for(var j = 0; j < this.productInfoList[i].Products.length;j++){
          var skuId = this.productInfoList[i].Products[j].SkuId
          var count = this.getCartItemCount(skuId)
          skuIds.push({skuId:skuId,  count:count , activityType:0})
        }
      }  
      var couponChooseList = []
      for(var i = 0; i< this.orderSubmitDto.shopOrder.length;i ++){
        if(this.orderSubmitDto.shopOrder[i].couponNumber){
          couponChooseList.push(this.orderSubmitDto.shopOrder[i].couponNumber)
        }
      }
      for(var i = 0; i < this.platformCouponCheckList.length;i++){
		couponChooseList.push(this.platformCouponCheckList[i])
      }	  
      const ths = this;
      this.$post('/Shop/CouponServer/WapCouponUseList', { SkuIds: skuIds, Baw: 0, CouponNumbers: couponChooseList, shopId: '', rangeType: 0})
        .then(function (res) {
          if(res.IsSuccess){
            ths.currentPlatformUsefulCouponList = res.Data
            ths.loaded = false
          }   
        })
        .catch(function (err) {
		  ths.loaded = false
		  ths.platformCouponCheckList = []
          console.log(err)
        })    
    },
    //查询可用的平台优惠券
    getPlatformUsefulCouponList(rangeType, showPopup, callback){
      if (this.closeCoupon){
        return
      }
	
	  this.activeTab = "1";
	  this.platformCouponCheckList = []
	  
      var skuIds = [];
      for(var i = 0; i< this.productInfoList.length;i++){
        for(var j = 0; j < this.productInfoList[i].Products.length;j++){
          var skuId = this.productInfoList[i].Products[j].SkuId
          var count = this.getCartItemCount(skuId)
          skuIds.push({skuId:skuId,  count:count , activityType:0})
        }
      }  
      var couponChooseList = []
      for(var i = 0; i< this.orderSubmitDto.shopOrder.length;i ++){
        if(this.orderSubmitDto.shopOrder[i].couponNumber){
          couponChooseList.push(this.orderSubmitDto.shopOrder[i].couponNumber)
        }
      }
      for(var i = 0; i < this.orderSubmitDto.platformCouponList.length;i++){
		couponChooseList.push(this.orderSubmitDto.platformCouponList[i].couponNumber)
		this.platformCouponCheckList.push(this.orderSubmitDto.platformCouponList[i].couponNumber)
      }
      const ths = this;
      this.$post('/Shop/CouponServer/WapCouponUseList', { SkuIds: skuIds, Baw: 0, CouponNumbers: couponChooseList, shopId: '', rangeType: rangeType})
        .then(function (res) {
          if(res.IsSuccess){
            ths.currentPlatformUsefulCouponList = res.Data
            /**
			if(rangeType == 1){
              ths.HasPlatformCoupon1 = true
            }
            else if(rangeType == 2){
              ths.HasPlatformCoupon2 = true
            }
            else if(rangeType == 0){
              ths.HasPlatformCoupon0 = true
            }
			**/
			for (var i=0;i<ths.orderSubmitDto.platformCouponList.length;i++){
				var isFind = false
				for (var j=0;j<res.Data.CouponUseItem.length;j++){
					if (ths.orderSubmitDto.platformCouponList[i].couponNumber == res.Data.CouponUseItem[j].CouponNumber){
						isFind = true;
					}
				}
				if (!isFind){
					for (var j=0;j<ths.platformCouponCheckList.length;j++){
						if (ths.orderSubmitDto.platformCouponList[i].couponNumber == ths.platformCouponCheckList[j]){
							ths.platformCouponCheckList.splice(j,1)
							break
						}
					}
					ths.orderSubmitDto.platformCouponList.splice(i,1)
					i--
				}
			}
			ths.getMyCouponList()
          }         
          ths.platformCouponPopup = showPopup

          if(typeof callback == 'function'){
            callback(ths)
          }
        })
        .catch(function (err) {
          console.log(err)
        })    
    },
    //弹出平台优惠券选择
    openPlatformCoupon(rangeType){
      this.currentPlatformRangeType = rangeType      
      this.getPlatformUsefulCouponList(rangeType, true)
    },
    //选中平台优惠券（优惠券编号，门槛，优惠金额）
    checkBoxPlatformCoupon(couponNumber, fullMoney, couponMoney){
      /**单选的	
      if(!this.platformCouponCheckList ||this.platformCouponCheckList[0] != couponNumber){
        this.platformCouponCheckList = [couponNumber]
      }
      this.currentPlatformCouponInfo.FullMoney = fullMoney
      this.currentPlatformCouponInfo.Money = couponMoney
	  **/
	  
	  
	  
	  //锁住，不能选择
	  this.loaded = true
	  //换成多选的
	  for (var i=0;i<this.platformCouponCheckList.length;i++){
	    //如果列表里有，就取消选择
		if (this.platformCouponCheckList[i] == couponNumber){
			this.platformCouponCheckList.splice(i,1);
			this.getSelectPlatformUsefulCouponList()
			return
		}
	  }
	  this.platformCouponCheckList.push(couponNumber)
	  this.getSelectPlatformUsefulCouponList()
    },
    //确定选择平台优惠券
    checkPlatformCoupon(){
      if(this.platformCouponCheckList.length ==0 ){
		this.orderSubmitDto.platformCouponList = []
      }else{
	    //先加
		for(var i = 0; i < this.platformCouponCheckList.length; i++){
		  var isHas = false
		  var platformCouponItem = {}
		  for(var j = 0; j < this.orderSubmitDto.platformCouponList.length;j++){
		    if (this.orderSubmitDto.platformCouponList[j].couponNumber == this.platformCouponCheckList[i]){			  
			  isHas = true
			  break;
			}
		  }
		  if (!isHas){
		    for(var j = 0; j < this.currentPlatformUsefulCouponList.CouponUseItem.length;j++){
			    if (this.currentPlatformUsefulCouponList.CouponUseItem[j].CouponNumber == this.platformCouponCheckList[i]){
					platformCouponItem = {rangeType: this.currentPlatformUsefulCouponList.CouponUseItem[j].RangeType, couponNumber: this.platformCouponCheckList[i],'info': {FullMoney:this.currentPlatformUsefulCouponList.CouponUseItem[j].FullMoney, Money: this.currentPlatformUsefulCouponList.CouponUseItem[j].Money}}
					break
				}				
			}
			this.orderSubmitDto.platformCouponList.push(platformCouponItem)
		  }
		}
		
		//后删
		for(var i = 0; i < this.orderSubmitDto.platformCouponList.length;i++){
		  var isHas = false
		  for(var j = 0; j < this.platformCouponCheckList.length; j++){
		    if (this.orderSubmitDto.platformCouponList[i].couponNumber == this.platformCouponCheckList[j]){
			  isHas = true
			  break;
			}
		  }
		  if (!isHas){
		    //删
			this.orderSubmitDto.platformCouponList.splice(i,1)
			i--
		  }
		}
		
		
      }
	  
	  this.getMyCouponList()      
      console.info(this.orderSubmitDto)
      this.closePlatformCoupon()
    },
    //关闭平台优惠券选择
    closePlatformCoupon(){
      this.loaded = false
      this.platformCouponPopup = false
	  this.platformCouponCheckList = []
	  /**
      this.currentPlatformCouponInfo.FullMoney = 0
      this.currentPlatformCouponInfo.Money = 0
	  this.platformCouponCheckList = []
	  **/
    },   
    //获取已使用平台优惠券各类型券
    getPlatformCouponChoose(type){
	  var infoString = ""
      if(this.orderSubmitDto.platformCouponList){
        for(var i =0; i< this.orderSubmitDto.platformCouponList.length;i++){
          if(this.orderSubmitDto.platformCouponList[i].rangeType == type){
            var info = this.orderSubmitDto.platformCouponList[i].info
			if (infoString != ""){
				infoString += ","
			}
			infoString += '满'+ info.FullMoney+'减'+ info.Money+'元'
          }
        }
      }
	  if (infoString != ""){
		return infoString
	  } else {
		return '请选择'
	  }
      
    }, 
	//使用最优推荐组合
    getBast(){
	  this.closePlatformCoupon()
	  this.initPlatformCouponChoose()
	  this.getBestCoupon()
	},
    //清空已选择平台券
    initPlatformCouponChoose(){      
      this.platformCouponCheckList = []
      this.orderSubmitDto.platformCouponList = []
      this.HasPlatformCoupon1 = false
      this.HasPlatformCoupon2 = false
      this.HasPlatformCoupon0 = false
    },
    //获取整个订单总价格
    getAllOrderMoney(){
      var cnt = 0;
      for(var i =0; i < this.productInfoList.length;i++){
        cnt += this.productInfoList[i].TotalMoney
      }

      cnt = cnt - this.getAllOrderCouponMoney() + this.getAllOrderFreight()	  
      return cnt
    },
    //获取整个订单优惠券金额
    getAllOrderCouponMoney(){
      var cnt = 0;
      for(var i =0; i < this.productInfoList.length;i++){
        cnt += this.productInfoList[i].ShopCouponMoney
      }
      for(var i =0 ;i< this.orderSubmitDto.platformCouponList.length;i++){
        cnt += this.orderSubmitDto.platformCouponList[i].info.Money
      }
	  if (this.isCandy){
	    cnt += this.showMoney / this.candyRate;
	  }
      return cnt
    },
    //获取整个订单的邮费
    getAllOrderFreight(){
      var cnt = 0;
      for(var i =0; i < this.productInfoList.length;i++){
        cnt += this.productInfoList[i].FreightMoney
      }
      return cnt
    },
    //获取整个购物车的数量
    getAllCartCount(){
      var cnt = 0;
      for(var i =0; i < this.productInfoList.length;i++){
        cnt += this.productInfoList[i].CartCount
      }
      return cnt
    },
    //根据SKUId获取购物车数量
    getCartItemCount: function(skuId){
      var cartList = cart.getSelectList()
      if(this.$route.query.skuId>0){
        cartList = [{skuId:skuId,count: this.$route.query.count }]
      }

      for(var i=0;i< cartList.length;i++){
        if(cartList[i].skuId == skuId){          
          return cartList[i].count
        }
      }
    },
	closeFapiao(){
	  this.isFapiao = false
	  this.fapiaoPopup = false
	},
    closeChooseFapiao (){
      if(this.orderSubmitDto.InvoiceHead && this.orderSubmitDto.InvoiceHead.length>25){
        this.$refs.XRtoast.failed("不能超过25个字符", true)
        return
      }
	  if(this.orderSubmitDto.InvoiceHead.length==0){
        this.isFapiao = false
      }
      this.fapiaoPopup = false
    },
    //提交订单
    orderSubmit(){
      if(!this.orderSubmitDto.shopOrder || this.orderSubmitDto.shopOrder.length==0){
        this.$refs.XRtoast.failed("购物车不能为空", true)
        return
      }
      for(var i = 0; i< this.orderSubmitDto.shopOrder.length;i++){
        for(var j = 0; j < this.productInfoList.length; j++){
          if(this.orderSubmitDto.shopOrder[i].shopId == this.productInfoList[i].ShopId){
            this.orderSubmitDto.shopOrder[i].mobile = this.productInfoList[i].Mobile
            this.orderSubmitDto.shopOrder[i].remark = this.productInfoList[i].Remark
            this.orderSubmitDto.shopOrder[i].shippingMethodId = this.productInfoList[i].DeliveryType
            this.orderSubmitDto.shopOrder[i].shippingDateId = this.productInfoList[i].DeliveryDate
            if(this.productInfoList[i].SelfPickUpInfo){
              this.orderSubmitDto.shopOrder[i].selfPickUpSiteShopId = this.productInfoList[i].SelfPickUpInfo.shopId
            }
            if(this.productInfoList[i].SelfPickUpDate1 && this.productInfoList[i].SelfPickUpDate2){
              this.orderSubmitDto.shopOrder[i].selfPickUpDate = this.productInfoList[i].SelfPickUpDate1 + ' ' + this.productInfoList[i].SelfPickUpDate2
            }
            console.info(this.productInfoList[i])
          }
        }


        if(!this.orderSubmitDto.shopOrder[i].shippingMethodId || this.orderSubmitDto.shopOrder[i].shippingMethodId==0){
          this.$refs.XRtoast.failed("请选择配送方式", true)
          return
        }
        if(this.orderSubmitDto.shopOrder[i].shippingMethodId == 3){
          if(!this.orderSubmitDto.shopOrder[i].selfPickUpSiteShopId){
            this.$refs.XRtoast.failed("请选择自提点", true)
            return          
          }
          if(!this.orderSubmitDto.shopOrder[i].selfPickUpDate){
            this.$refs.XRtoast.failed("请选择自提时间", true)
            return
          }
        }else{        
          if(!this.orderSubmitDto.addrId || this.orderSubmitDto.addrId==0){
            this.$refs.XRtoast.failed("请选择收货地址", true)
            return
          }
          if(!this.orderSubmitDto.shopOrder[i].shippingDateId || this.orderSubmitDto.shopOrder[i].shippingDateId==0){
            this.$refs.XRtoast.failed("请选择配送时间", true)
            return
          }
        }
      }

	  if (this.isCandy){
        this.orderSubmitDto.baw = this.showMoney
	  } else {
	    this.orderSubmitDto.baw = 0
	  }
	  this.orderSubmitDto.isBaw = this.isCandy
      this.orderSubmitDto.candyName = this.candyName

      var ths = this
      ths.$post(
        "/Shop/RetailServer/OrderSubmit",
        JSON.stringify(this.orderSubmitDto)
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{
		  var ShopIds = window.localStorage['SelfShopIdUpInfo']
		  if (ShopIds){
		    ShopIds = JSON.parse(ShopIds)
		    for(var i = 0; i < ShopIds.ShopIds.length;i++){
			  //自提点信息
              window.localStorage.removeItem(ShopIds.ShopIds[i] + 'SelfPickUpShopInfo')
			  //其他物流信息
			  window.localStorage.removeItem(ShopIds.ShopIds[i] + 'SelfDeliveryUpShopInfo')
		    }
		  }
		  //优惠券信息
		  window.localStorage.removeItem('SelfCouponUpInfo')
		  //订单缓存过的所有shopid的售合
		  window.localStorage.removeItem('SelfShopIdUpInfo')
          ths.orderNos = res.Data
          ths.$refs.XRtoast.success(res.Msg, true)
          cart.clearSelectList()
        }
      });
    },
    //提交成功后的回调
    submitSuccess(){
      this.$router.push('/retail/orderPay?orderNo='+this.orderNos.join(','))
    },
	//平台优惠券选取切换
	handleTabChange (val) {
      this.activeTab = val
    },
  },
  watch :{ 
    isFapiao(){
	  if (this.isFapiao){
	    this.fapiaoPopup = true
	  } else {
	    this.orderSubmitDto.InvoiceHead = ""
	  }
    },
	/**
	isCandy(){
	  if (this.showMoney == 0 && this.isCandy){
	    this.isCandy = false
		this.isDisabled = true
	  }
	  if (this.showMoney > 0){
	    this.isDisabled = false
	  }
	}
	**/
  },
  beforeRouteEnter(to, from, next){
	to.query.fromUrl = from.path
    //判断从哪个页面进来
    next(vm => {
      vm.url = from.path;
      console.log(from.path)
      console.log( vm.url)
    })
  }

}
</script>
<style>
.retailOrderSubmitpage{
  background: #F0F2F5;
  bottom: unset;
}
.pageContent{
  padding-bottom: 56px;
}

.retailOrderSubmitpage .goIcon{
  width: 20px;
  float: right;
  text-align: right;
}
.retailOrderSubmitpage .goIcon.wuliu{
  line-height: 48px;
}
.retailOrderSubmitpage .goIcon.selfPick{
  line-height: 48px;
}

.retailOrderSubmitpage .mapIcon{
  float: left;
  width: 30px;
  line-height: 40px;
}
.retailOrderSubmitpage .mapIcon img{
  width:100%;
  display: block;
  margin-top: 13px;
}

.retailOrderSubmitpage .receive-address{
  background: white;
  color:black;
  padding: 20px 20px;
  overflow: hidden;
  margin-top: 12px;
  border-radius: 10px;
}
.retailOrderSubmitpage .receive-address .address-info{
  float: left;
  margin-left: 10px;
}
.retailOrderSubmitpage .receive-address .address-info .name{
  font-size:16px;
  padding-right: 10px;
}
.retailOrderSubmitpage .receive-address .address-info .mobile{
  font-size:14px;
  color:#aaa;
}
.retailOrderSubmitpage .receive-address .address-info .address-content{
  font-size:12px;
  color:#666;
  line-height: 14px;
  height: 28px;
  margin-top: 5px;
}
.retailOrderSubmitpage .receive-address .address-info .address-content .fa{
  width: 20px;
}
.retailOrderSubmitpage .receive-address .goIcon{
  width:20px;
  height: 14px;
  margin-top: 20px;
}

.retailOrderSubmitpage .info-area{
  margin-top : 12px;
  border-radius: 10px;
  overflow: hidden;
}
.retailOrderSubmitpage .choose-info{
  overflow: hidden;
  background: white;
  padding:10px 30px;
}
.retailOrderSubmitpage .choose-info.fapiao-area{
  padding:20px 30px 10px;
}
.retailOrderSubmitpage .choose-info.platformCoupon{
  padding:20px 30px 10px;
}
.retailOrderSubmitpage .choose-info.delivery{
  padding-top: 30px;
}
.retailOrderSubmitpage .choose-info.integral{
  padding:10px 30px 20px;
}
.retailOrderSubmitpage .choose-info .info{
  font-size: 12px;
  float: left;
  line-height: 24px;
}
.retailOrderSubmitpage .choose-info .info.left {
  width: 80px;
}
.retailOrderSubmitpage .choose-info .info.left .title{
  font-size: 14px;
  color:black;
}
.retailOrderSubmitpage .choose-info .info .choose-row{
  line-height: 24px;
}
.retailOrderSubmitpage .choose-info .info .choose-row.one{
  line-height: 24px;
}
.retailOrderSubmitpage .choose-info .info.center{
  padding-left: 10px;
}
.retailOrderSubmitpage .choose-info .info.center .choose-row{
  text-align: left;
  color: #A0A0A0; 
}
.retailOrderSubmitpage .choose-info .info.right{
  float:right;
}
.retailOrderSubmitpage .choose-info .info.right .choose-row{
  text-align: right;
  color: #A0A0A0; 
}

.retailOrderSubmitpage .choose-info.integral .info.left .choose-row.balance{
  color:red;
}
.retailOrderSubmitpage .choose-info.integral .info.center .choose-row.integralModify{
  color:red;
}
.retailOrderSubmitpage .info.center .choose-row.ziti{
  float: left;
}

.retailOrderSubmitpage .remark{
  background: white;
  padding:10px 30px;
}

.retailOrderSubmitpage .price-info{
  background: white;
  margin-top: 25px;
  padding:10px 10px 40px;
  border-radius: 10px 10px 0 0;
}
.retailOrderSubmitpage .price-info .row{
  background: white;
  overflow: hidden;
  line-height: 32px;
}
.retailOrderSubmitpage .price-info .row .title{
  font-size: 14px;
  font-weight: 700;
}
.retailOrderSubmitpage .price-info .row .price{
  color:Red;
  font-weight: 700;
}


.retailOrderSubmitpage .shopProductList{
  overflow:hidden;
  border-radius: 10px;
  margin-top: 12px;
}
.retailOrderSubmitpage .shopProductList .shopRow{
  background: white;
  overflow: hidden;
  color:#666;
  width: 100%;
  padding: 15px 10px;
}
.retailOrderSubmitpage .shopProductList .shopRow .all-chk{
  float: left;
  width: 40px;
  margin-top: 6px;
  text-align: center;
}
.retailOrderSubmitpage .shopProductList .shopRow .shopName{
  padding-left: 10px;
  vertical-align: middle;
}
.retailOrderSubmitpage .shopProductList .shopRow .shopName .shopLogo{
  float: left;
  width:20px;
  height: 20px;
  border-radius: 50%;
}
.retailOrderSubmitpage .shopProductList .shopRow .shopName .shopNameValue{
  float: left;
  height: 20px;
  line-height: 20px;
  margin-left: 5px;
  font-size: 14px;
}


.retailOrderSubmitpage .shopProductList .pro-list{
  background: #fcfcfc;
  overflow: hidden;
}
.retailOrderSubmitpage .shopProductList .pro-list .pro-item{
  padding: 16px 0;
  overflow: hidden;
}
.retailOrderSubmitpage .shopProductList .pro-list .pro-item .pro-img{
  width: 80px;
  float: left;
}
.retailOrderSubmitpage .shopProductList .pro-list .pro-item .pro-img img{
  width: 100%;
  display: block;
  border-radius: 4px;
  margin: 0 20px;
  height: 80px;
  object-fit: cover;
}
.retailOrderSubmitpage .shopProductList .pro-list .pro-item .pro-info{
  float: right;
  padding-right: 10px;
}
.retailOrderSubmitpage .shopProductList .pro-list .pro-item .pro-info .pro-name{
  font-size: 12px;
  line-height: 16px;
  height: 32px;
  padding-bottom: 4px;
  overflow: hidden;
}
.retailOrderSubmitpage .shopProductList .pro-list .pro-item .pro-info .pro-attr{
  font-size: 12px;
  line-height: 16px;
  height: 30px;
  color:#999;
  overflow:hidden;
}
.retailOrderSubmitpage .shopProductList .pro-list .pro-item .pro-info .pro-num{
  font-size: 12px;
  line-height: 16px;
  height: 16px;
  color:#999;
}
.retailOrderSubmitpage .shopProductList .pro-list .pro-item .pro-info .pro-num .pro-price{
  font-size: 16px;
  line-height: 16px;
  float: left;
  color:red;
}
.retailOrderSubmitpage .shopProductList .pro-list .pro-item .pro-info .pro-num .jiajian-ctrl{
  float: right;
}
.retailOrderSubmitpage .shopProductList .pro-list .pro-item .pro-info .pro-num .jiajian-ctrl span{
  float: left;
  width: 20px;
  text-align: center;
}
.retailOrderSubmitpage .shopProductList .pro-list .pro-item .pro-info .pro-num .jiajian-ctrl .count{
  border: 1px solid #eee;
  width: 30px;
  border-left: 0;
  border-right: 0;
}
.retailOrderSubmitpage .shopProductList .pro-list .pro-item .pro-info .pro-num .jiajian-ctrl .btn{
  border: 1px solid #eee;
}
.retailOrderSubmitpage .shopProductList .pro-list .pro-item .pro-info .pro-num .jiajian-ctrl .jian{
  border-radius:2px 0 0 2px;
}
.retailOrderSubmitpage .shopProductList .pro-list .pro-item .pro-info .pro-num .jiajian-ctrl .jia{
  border-radius:0 2px 2px 0;
}

.retailOrderSubmitpage .shopProductList .area-total{
  overflow: hidden;
  background: white;
  line-height: 20px;
  padding:10px 30px 20px;
}
.retailOrderSubmitpage .shopProductList .area-total p{
  float: right;
}
.retailOrderSubmitpage .shopProductList .area-total .left{
  color:#B6B6B7;
  font-size: 12px;
  margin-right: 5px;
}
.retailOrderSubmitpage .shopProductList .area-total .center{
  color:black;
  font-size: 16px;
}
.retailOrderSubmitpage .shopProductList .area-total .right{
  color:red;
  font-size: 16px;
}


.retailOrderSubmitpage .platformCouponChooseList{
  border-radius: 10px;
  margin: 12px 0;
  overflow: hidden;
}
.retailOrderSubmitpage .platformCouponChooseList .couponSelectList{
  padding: 0;
}
.retailOrderSubmitpage .platformCouponChooseList .couponSelectList .couponListItem{
  overflow: hidden;
  padding: 0 0 10px;
}
.retailOrderSubmitpage .platformCouponChooseList .couponSelectList .couponListItem.groupLine{
  border-bottom: 1px dashed #dedede;
}
.retailOrderSubmitpage .platformCouponChooseList .couponSelectList .couponListItem .couponIcon{
  float: left;
  width: auto;
  line-height: 20px;
  text-align: center;
  padding-top: 2px;
  color:#E62129;  
}
.retailOrderSubmitpage .platformCouponChooseList .couponSelectList .couponListItem .couponIcon .couponIconContent{
  position: relative;
  overflow:hidden;
  border-radius: 5px;
  border:1px solid #E62129;
  padding-left:5px;
  padding-right:5px;
}
.retailOrderSubmitpage .platformCouponChooseList .couponSelectList .couponListItem .couponValue{
  float: right;
  padding-right:10px;
  color:#A1A1A1;
}
.retailOrderSubmitpage .platformCouponChooseList .couponSelectList .couponListItem .couponChk{
  width:25px;
  float: right;
}


.retailOrderSubmitpage .bottom-bar{
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: white;
  height: 56px;
  border-top:1px solid #eee;
  z-index: 9999;
}
.retailOrderSubmitpage .bottom-bar .cart-money{
  overflow: hidden;
  height: 30px;
  line-height: 30px;
  padding-top: 8px;
  padding-right: 10px;
}
.retailOrderSubmitpage .bottom-bar .cart-money .cart-freightMoney{
  float: right;
  color:#A1A1A1;
  margin-right: 5px;
}
.retailOrderSubmitpage .bottom-bar .cart-money .cart-total{
  float: right;
  font-size: 14px;
  font-weight: 700;
  color:black;
}
.retailOrderSubmitpage .bottom-bar .cart-money .cart-total i.fa{
  color:Red;
}
.retailOrderSubmitpage .bottom-bar .cart-money .cart-total .money{
  color:Red;
}
.retailOrderSubmitpage .bottom-bar .cart-discount{
  float: right;
  font-size: 14px;
  color:Red;
  height: 20px;
  line-height: 20px;
  padding-right: 10px;
}
.retailOrderSubmitpage .gobuy{
  width: 100%;
  line-height: 56px;
  height: 56px;
  text-align: center;
}

.retailOrderSubmitpage-popupLayer {
  width: 100%;
  min-height: 120px;
}
.retailOrderSubmitpage-popupLayer .mu-raised-button-primary{
  background: red;
}
.retailOrderSubmitpage-popupLayer .deliveryChoose {
  padding: 0 10px;
}
.retailOrderSubmitpage-popupLayer .delvieryChooseBtn{
  margin: 40px 0 0;
  height: 50px; 
}

.retailOrderSubmitpage-popupLayer .shippingBtn.select{
  background: red;
  color:white;
}
.retailOrderSubmitpage-popupLayer .couponListTilte{
  padding:20px 0 10px;
  text-align: center;
  font-size: 14px;
  color:black;
}
.retailOrderSubmitpage-popupLayer .couponList{
  height: 300px;
  overflow-x: hidden;
  overflow-y: scroll;
  padding: 0 16px;
}
.retailOrderSubmitpage-popupLayer .couponList .couponListItem{
  overflow: hidden;
  padding: 10px 0;
}
.retailOrderSubmitpage-popupLayer .couponList .couponListItem.groupLine{
  border-bottom: 1px dashed #dedede;
}
.retailOrderSubmitpage-popupLayer .couponList .couponListItem .couponIcon{
  float: left;
  width: 46px;
  line-height: 20px;
  text-align: center;
  margin-right: 10px;
}
.retailOrderSubmitpage-popupLayer .couponList .couponListItem .couponIcon .couponIconContent{
  position: relative;
  overflow:hidden;
}
.retailOrderSubmitpage-popupLayer .couponList .couponListItem .couponIcon .couponIconContent p{
  position:absolute;
  left:0;
  right:0;
  text-align: center;
  color:white;
  font-size: 12px;
}
.retailOrderSubmitpage-popupLayer .couponList .couponListItem .couponIcon .couponIconContent img{
  width:100%;
}
.retailOrderSubmitpage-popupLayer .couponList .couponListItem .couponValue{
  float: left;
  color:#A1A1A1;
}
.retailOrderSubmitpage-popupLayer .couponList .couponListItem.disabled .couponValue{
  color:#dedede;
}

.retailOrderSubmitpage-popupLayer .couponList .couponListItem .couponOperator{
  float: left;
  width: 24px;
}
.retailOrderSubmitpage-popupLayer .couponList .couponListItem .couponOperator .mu-checkbox .mu-checkbox-icon-uncheck{
  color:#A1A1A1;
}
.retailOrderSubmitpage-popupLayer .couponList .couponListItem.disabled .couponOperator .mu-checkbox .mu-checkbox-icon-uncheck{
  color:#dedede;
}

.platformCouponPopup{
  border-radius:15px;
}

.platformCouponPopup .platformCouponListTilte{
  float:left;
  text-align:left;  
  padding-left:15px;
  padding-top:20px;
  font-size:22px;
  color:#000;
  font-weight:bold;
}

.platformCouponPopup .couponClose{
  float:right;
  padding-right:15px;
  padding-top:20px;
}

.platformCouponPopup .mu-tabs{
  background: #fff;
  border-bottom:2px solid #DCDDDD;
}
.platformCouponPopup .mu-tabs .mu-tab-link .mu-tab-text{
  color: #383130;
  font-size:16px;
}
.platformCouponPopup .mu-tabs .mu-tab-active .mu-tab-text{
  color: #332C2B;
  font-weight:bold;
  font-size:16px;
}
.platformCouponPopup .platformCouponSelectMsg{
  float:left;
  text-align:left;  
  margin-left:15px;
  margin-top:15px;
  font-size:14px;
  color:#332C2B;
}
.platformCouponPopup .platformCouponBestBtn{
  float:right;
  text-align:center;
  width:100px;
  height:22px;
  margin-right:10px;
  margin-top:15px;
  color:#fff;
  background: #E62129; 
  border-radius:15px;  
}


.platformCouponPopup .platformCouponList{
  height: 280px;
  background:#F6F4F7;
  overflow-x: hidden;
  overflow-y: scroll;
}

.platformCouponPopup .platformCouponList .couponListItem{
  margin:12px 12px 0px 12px;
  width: auto;
  height:100px;
  display: flex;
}
.platformCouponPopup .platformCouponList .couponListItem .platformCouponMoney{
  float:left;
  width: 90px;
  height: 100px;
}
.platformCouponPopup .platformCouponList .couponListItem .platformCouponMoney .keyongMoney{
  display:block;
  width: 90px;
  height: 100px;
  padding-top:10px;
  background:#E51284;
  color:#E84387;
  border-top-left-radius:8px;
  border-bottom-left-radius:8px;
  text-align:center;
}
.platformCouponPopup .platformCouponList .couponListItem .platformCouponMoney .bukeyongMoney{
  display:block;
  width: 90px;
  height: 100px;
  padding-top:10px;
  background:#D4D4D4;
  color:#757475;
  border-top-left-radius:8px;
  border-bottom-left-radius:8px;
  text-align:center;
}
.platformCouponPopup .platformCouponList .couponListItem .platformCouponMoney .MoneyCircle{
  display:block;
  overflow:hidden;
  width: 52px;
  height: 52px;
  background:#fff;
  border-radius:50%;
  margin:0px auto 0px auto;
}
.platformCouponPopup .platformCouponList .couponListItem .platformCouponMoney .MoneyCircle .cost{
  height: 20px;
  line-height: 30px;
}

.platformCouponPopup .platformCouponList .couponListItem .platformCouponMoney .MoneyCircle .money{
  font-size: 24px;
  height: 30px;
  line-height: 30px;
}

.platformCouponPopup .platformCouponList .couponListItem .platformCouponMoney .FullMoney {
  font-size: 14px;
  height: 30px;
  line-height: 30px;
  color:#fff;
}

.platformCouponPopup .platformCouponList .couponListItem .platformCouponSel{
  float:left;
  background-image: url('/static/coupon/platformCouponItemBg.png');
  background-repeat:no-repeat;
}

.platformCouponPopup .platformCouponList .couponListItem .platformCouponSel .dor{
  float:left;
  width:5px;
  padding: 0 5px 0 0;
  margin-top:13px;
  margin-left:4px;
  border-left: 1px dotted #999;
  height: 77px;
  
}

.platformCouponPopup .platformCouponList .couponListItem .platformCouponSel .keyongSel{
  float:left;
  height: 100px;
  background:#FFF;
  border-top-right-radius:8px;
  border-bottom-right-radius:8px;
  position:relative;
}

.platformCouponPopup .platformCouponList .couponListItem .platformCouponSel .keyongSel .selContent{
  position:absolute;
  top:15px;
  left:8px;
  font-size:16px;
  line-height:150%;
  color:#332C2B;
}

.platformCouponPopup .platformCouponList .couponListItem .platformCouponSel .keyongSel .selContent .selType{
  background:#E62129;
  border-radius:15px;
  padding:3px 6px 3px 6px;
  color:#fff;
  font-size:12px;
  margin-right:5px;
}

.platformCouponPopup .platformCouponList .couponListItem .platformCouponSel .keyongSel .selContent .selDate{
  font-size:11px;
  color:#474443;
}

.platformCouponPopup .platformCouponList .couponListItem .platformCouponSel .keyongSel .selBtn{
  position:absolute;
  top:40px;
  right:18px;
}





.platformCouponPopup .platformCouponList .couponListItem .platformCouponSel .bukeyongSel{
  float:left;
  height: 100px;
  background:#FFF;
  border-top-right-radius:8px;
  border-bottom-right-radius:8px;
  position:relative;
}

.platformCouponPopup .platformCouponList .couponListItem .platformCouponSel .bukeyongSel .selContent{
  position:absolute;
  top:15px;
  left:8px;
  font-size:16px;
  line-height:150%;
  color:#A1A1A1;
}

.platformCouponPopup .platformCouponList .couponListItem .platformCouponSel .bukeyongSel .selContent .selType{
  background:#A1A1A1;
  border-radius:15px;
  padding:3px 6px 3px 6px;
  color:#fff;
  font-size:12px;
  margin-right:5px;
}

.platformCouponPopup .platformCouponList .couponListItem .platformCouponSel .bukeyongSel .selContent .selDate{
  font-size:11px;
  color:#A1A1A1;
}

.platformCouponPopup .platformCouponList .couponListItem .platformCouponSel .bukeyongSel .selBtn{
  position:absolute;
  top:40px;
  right:18px;
}




.platformCouponPopup .platformDelvieryChooseBtn{
  height: 50px; 
}



.retailOrderSubmitpage-popupLayer .dateChoose{
  padding: 0 10px;
  display: flex;
}
.dateChoose .dateleft{
width: 50%;
}
.dateChoose .daterigth{
  width: 50%;
  text-align: right;
  text-align: -webkit-right;
}
.dateChoose .active{
  background: red;
  color:white;
}
.dateChoose .daterigth .mu-raised-button{
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/pages/retail/orderSubmit.vue